var _excluded = ["children"],
  _excluded2 = ["control", "onSubmit", "children", "action", "method", "headers", "encType", "onError", "render", "onSuccess", "validateStatus"],
  _excluded3 = ["_f"],
  _excluded4 = ["name"],
  _excluded5 = ["_f"],
  _excluded6 = ["ref", "message", "type"],
  _excluded7 = ["formControl"];
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _regeneratorRuntime() { "use strict"; var r = _regenerator(), e = r.m(_regeneratorRuntime), t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor; function n(r) { var e = "function" == typeof r && r.constructor; return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name)); } var o = { throw: 1, return: 2, break: 3, continue: 3 }; function a(r) { var e, t; return function (n) { e || (e = { stop: function stop() { return t(n.a, 2); }, catch: function _catch() { return n.v; }, abrupt: function abrupt(r, e) { return t(n.a, o[r], e); }, delegateYield: function delegateYield(r, o, a) { return e.resultName = o, t(n.d, _regeneratorValues(r), a); }, finish: function finish(r) { return t(n.f, r); } }, t = function t(r, _t, o) { n.p = e.prev, n.n = e.next; try { return r(_t, o); } finally { e.next = n.n; } }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n; try { return r.call(this, e); } finally { n.p = e.prev, n.n = e.next; } }; } return (_regeneratorRuntime = function _regeneratorRuntime() { return { wrap: function wrap(e, t, n, o) { return r.w(a(e), t, n, o && o.reverse()); }, isGeneratorFunction: n, mark: r.m, awrap: function awrap(r, e) { return new _OverloadYield(r, e); }, AsyncIterator: _regeneratorAsyncIterator, async: function async(r, e, t, o, u) { return (n(e) ? _regeneratorAsyncGen : _regeneratorAsync)(a(r), e, t, o, u); }, keys: _regeneratorKeys, values: _regeneratorValues }; })(); }
function _regeneratorValues(e) { if (null != e) { var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0; if (t) return t.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) return { next: function next() { return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e }; } }; } throw new TypeError(_typeof(e) + " is not iterable"); }
function _regeneratorKeys(e) { var n = Object(e), r = []; for (var t in n) r.unshift(t); return function e() { for (; r.length;) if ((t = r.pop()) in n) return e.value = t, e.done = !1, e; return e.done = !0, e; }; }
function _regeneratorAsync(n, e, r, t, o) { var a = _regeneratorAsyncGen(n, e, r, t, o); return a.next().then(function (n) { return n.done ? n.value : a.next(); }); }
function _regeneratorAsyncGen(r, e, t, o, n) { return new _regeneratorAsyncIterator(_regenerator().w(r, e, t, o), n || Promise); }
function _regeneratorAsyncIterator(t, e) { function n(r, o, i, f) { try { var c = t[r](o), u = c.value; return u instanceof _OverloadYield ? e.resolve(u.v).then(function (t) { n("next", t, i, f); }, function (t) { n("throw", t, i, f); }) : e.resolve(u).then(function (t) { c.value = t, i(c); }, function (t) { return n("throw", t, i, f); }); } catch (t) { f(t); } } var r; this.next || (_regeneratorDefine2(_regeneratorAsyncIterator.prototype), _regeneratorDefine2(_regeneratorAsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function () { return this; })), _regeneratorDefine2(this, "_invoke", function (t, o, i) { function f() { return new e(function (e, r) { n(t, i, e, r); }); } return r = r ? r.then(f, f) : f(); }, !0); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _OverloadYield(e, d) { this.v = e, this.k = d; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import React from 'react';
var isCheckBoxInput = function isCheckBoxInput(element) {
  return element.type === 'checkbox';
};
var isDateObject = function isDateObject(value) {
  return value instanceof Date;
};
var isNullOrUndefined = function isNullOrUndefined(value) {
  return value == null;
};
var isObjectType = function isObjectType(value) {
  return _typeof(value) === 'object';
};
var isObject = function isObject(value) {
  return !isNullOrUndefined(value) && !Array.isArray(value) && isObjectType(value) && !isDateObject(value);
};
var getEventValue = function getEventValue(event) {
  return isObject(event) && event.target ? isCheckBoxInput(event.target) ? event.target.checked : event.target.value : event;
};
var getNodeParentName = function getNodeParentName(name) {
  return name.substring(0, name.search(/\.\d+(\.|$)/)) || name;
};
var isNameInFieldArray = function isNameInFieldArray(names, name) {
  return names.has(getNodeParentName(name));
};
var isPlainObject = function isPlainObject(tempObject) {
  var prototypeCopy = tempObject.constructor && tempObject.constructor.prototype;
  return isObject(prototypeCopy) && prototypeCopy.hasOwnProperty('isPrototypeOf');
};
var isWeb = typeof window !== 'undefined' && typeof window.HTMLElement !== 'undefined' && typeof document !== 'undefined';
function cloneObject(data) {
  var copy;
  var isArray = Array.isArray(data);
  var isFileListInstance = typeof FileList !== 'undefined' ? data instanceof FileList : false;
  if (data instanceof Date) {
    copy = new Date(data);
  } else if (!(isWeb && (data instanceof Blob || isFileListInstance)) && (isArray || isObject(data))) {
    copy = isArray ? [] : Object.create(Object.getPrototypeOf(data));
    if (!isArray && !isPlainObject(data)) {
      copy = data;
    } else {
      for (var key in data) {
        if (data.hasOwnProperty(key)) {
          copy[key] = cloneObject(data[key]);
        }
      }
    }
  } else {
    return data;
  }
  return copy;
}
var isKey = function isKey(value) {
  return /^\w*$/.test(value);
};
var isUndefined = function isUndefined(val) {
  return val === undefined;
};
var compact = function compact(value) {
  return Array.isArray(value) ? value.filter(Boolean) : [];
};
var stringToPath = function stringToPath(input) {
  return compact(input.replace(/["|']|\]/g, '').split(/\.|\[/));
};
var _get = function get(object, path, defaultValue) {
  if (!path || !isObject(object)) {
    return defaultValue;
  }
  var result = (isKey(path) ? [path] : stringToPath(path)).reduce(function (result, key) {
    return isNullOrUndefined(result) ? result : result[key];
  }, object);
  return isUndefined(result) || result === object ? isUndefined(object[path]) ? defaultValue : object[path] : result;
};
var isBoolean = function isBoolean(value) {
  return typeof value === 'boolean';
};
var set = function set(object, path, value) {
  var index = -1;
  var tempPath = isKey(path) ? [path] : stringToPath(path);
  var length = tempPath.length;
  var lastIndex = length - 1;
  while (++index < length) {
    var key = tempPath[index];
    var newValue = value;
    if (index !== lastIndex) {
      var objValue = object[key];
      newValue = isObject(objValue) || Array.isArray(objValue) ? objValue : !isNaN(+tempPath[index + 1]) ? [] : {};
    }
    if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
      return;
    }
    object[key] = newValue;
    object = object[key];
  }
};
var EVENTS = {
  BLUR: 'blur',
  FOCUS_OUT: 'focusout',
  CHANGE: 'change'
};
var VALIDATION_MODE = {
  onBlur: 'onBlur',
  onChange: 'onChange',
  onSubmit: 'onSubmit',
  onTouched: 'onTouched',
  all: 'all'
};
var INPUT_VALIDATION_RULES = {
  max: 'max',
  min: 'min',
  maxLength: 'maxLength',
  minLength: 'minLength',
  pattern: 'pattern',
  required: 'required',
  validate: 'validate'
};
var HookFormContext = /*#__PURE__*/React.createContext(null);
HookFormContext.displayName = 'HookFormContext';
/**
 * This custom hook allows you to access the form context. useFormContext is intended to be used in deeply nested structures, where it would become inconvenient to pass the context as a prop. To be used with {@link FormProvider}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @returns return all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */
var useFormContext = function useFormContext() {
  return React.useContext(HookFormContext);
};
/**
 * A provider component that propagates the `useForm` methods to all children components via [React Context](https://react.dev/reference/react/useContext) API. To be used with {@link useFormContext}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @param props - all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */
var FormProvider = function FormProvider(props) {
  var children = props.children,
    data = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(HookFormContext.Provider, {
    value: data
  }, children);
};
var getProxyFormState = function getProxyFormState(formState, control, localProxyFormState) {
  var isRoot = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var result = {
    defaultValues: control._defaultValues
  };
  var _loop = function _loop(key) {
    Object.defineProperty(result, key, {
      get: function get() {
        var _key = key;
        if (control._proxyFormState[_key] !== VALIDATION_MODE.all) {
          control._proxyFormState[_key] = !isRoot || VALIDATION_MODE.all;
        }
        localProxyFormState && (localProxyFormState[_key] = true);
        return formState[_key];
      }
    });
  };
  for (var key in formState) {
    _loop(key);
  }
  return result;
};
var useIsomorphicLayoutEffect = typeof window !== 'undefined' ? React.useLayoutEffect : React.useEffect;

/**
 * This custom hook allows you to subscribe to each form state, and isolate the re-render at the custom hook level. It has its scope in terms of form state subscription, so it would not affect other useFormState and useForm. Using this hook can reduce the re-render impact on large and complex form application.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformstate) • [Demo](https://codesandbox.io/s/useformstate-75xly)
 *
 * @param props - include options on specify fields to subscribe. {@link UseFormStateReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, control } = useForm({
 *     defaultValues: {
 *     firstName: "firstName"
 *   }});
 *   const { dirtyFields } = useFormState({
 *     control
 *   });
 *   const onSubmit = (data) => console.log(data);
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input {...register("firstName")} placeholder="First Name" />
 *       {dirtyFields.firstName && <p>Field is dirty.</p>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */
function useFormState(props) {
  var methods = useFormContext();
  var _ref = props || {},
    _ref$control = _ref.control,
    control = _ref$control === void 0 ? methods.control : _ref$control,
    disabled = _ref.disabled,
    name = _ref.name,
    exact = _ref.exact;
  var _React$useState = React.useState(control._formState),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    formState = _React$useState2[0],
    updateFormState = _React$useState2[1];
  var _localProxyFormState = React.useRef({
    isDirty: false,
    isLoading: false,
    dirtyFields: false,
    touchedFields: false,
    validatingFields: false,
    isValidating: false,
    isValid: false,
    errors: false
  });
  useIsomorphicLayoutEffect(function () {
    return control._subscribe({
      name: name,
      formState: _localProxyFormState.current,
      exact: exact,
      callback: function callback(formState) {
        !disabled && updateFormState(_objectSpread(_objectSpread({}, control._formState), formState));
      }
    });
  }, [name, disabled, exact]);
  React.useEffect(function () {
    _localProxyFormState.current.isValid && control._setValid(true);
  }, [control]);
  return React.useMemo(function () {
    return getProxyFormState(formState, control, _localProxyFormState.current, false);
  }, [formState, control]);
}
var isString = function isString(value) {
  return typeof value === 'string';
};
var generateWatchOutput = function generateWatchOutput(names, _names, formValues, isGlobal, defaultValue) {
  if (isString(names)) {
    isGlobal && _names.watch.add(names);
    return _get(formValues, names, defaultValue);
  }
  if (Array.isArray(names)) {
    return names.map(function (fieldName) {
      return isGlobal && _names.watch.add(fieldName), _get(formValues, fieldName);
    });
  }
  isGlobal && (_names.watchAll = true);
  return formValues;
};
var isPrimitive = function isPrimitive(value) {
  return isNullOrUndefined(value) || !isObjectType(value);
};
function deepEqual(object1, object2) {
  var _internal_visited = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new WeakSet();
  if (isPrimitive(object1) || isPrimitive(object2)) {
    return object1 === object2;
  }
  if (isDateObject(object1) && isDateObject(object2)) {
    return object1.getTime() === object2.getTime();
  }
  var keys1 = Object.keys(object1);
  var keys2 = Object.keys(object2);
  if (keys1.length !== keys2.length) {
    return false;
  }
  if (_internal_visited.has(object1) || _internal_visited.has(object2)) {
    return true;
  }
  _internal_visited.add(object1);
  _internal_visited.add(object2);
  for (var _i = 0, _keys = keys1; _i < _keys.length; _i++) {
    var key = _keys[_i];
    var val1 = object1[key];
    if (!keys2.includes(key)) {
      return false;
    }
    if (key !== 'ref') {
      var val2 = object2[key];
      if (isDateObject(val1) && isDateObject(val2) || isObject(val1) && isObject(val2) || Array.isArray(val1) && Array.isArray(val2) ? !deepEqual(val1, val2, _internal_visited) : val1 !== val2) {
        return false;
      }
    }
  }
  return true;
}

/**
 * Custom hook to subscribe to field change and isolate re-rendering at the component level.
 *
 * @remarks
 *
 * [API](https://react-hook-form.com/docs/usewatch) • [Demo](https://codesandbox.io/s/react-hook-form-v7-ts-usewatch-h9i5e)
 *
 * @example
 * ```tsx
 * const { control } = useForm();
 * const values = useWatch({
 *   name: "fieldName"
 *   control,
 * })
 * ```
 */
function useWatch(props) {
  var methods = useFormContext();
  var _ref2 = props || {},
    _ref2$control = _ref2.control,
    control = _ref2$control === void 0 ? methods.control : _ref2$control,
    name = _ref2.name,
    defaultValue = _ref2.defaultValue,
    disabled = _ref2.disabled,
    exact = _ref2.exact,
    compute = _ref2.compute;
  var _defaultValue = React.useRef(defaultValue);
  var _compute = React.useRef(compute);
  var _computeFormValues = React.useRef(undefined);
  var _prevControl = React.useRef(control);
  var _prevName = React.useRef(name);
  _compute.current = compute;
  var _React$useState3 = React.useState(function () {
      var defaultValue = control._getWatch(name, _defaultValue.current);
      return _compute.current ? _compute.current(defaultValue) : defaultValue;
    }),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    value = _React$useState4[0],
    updateValue = _React$useState4[1];
  var getCurrentOutput = React.useCallback(function (values) {
    var formValues = generateWatchOutput(name, control._names, values || control._formValues, false, _defaultValue.current);
    return _compute.current ? _compute.current(formValues) : formValues;
  }, [control._formValues, control._names, name]);
  var refreshValue = React.useCallback(function (values) {
    if (!disabled) {
      var formValues = generateWatchOutput(name, control._names, values || control._formValues, false, _defaultValue.current);
      if (_compute.current) {
        var computedFormValues = _compute.current(formValues);
        if (!deepEqual(computedFormValues, _computeFormValues.current)) {
          updateValue(computedFormValues);
          _computeFormValues.current = computedFormValues;
        }
      } else {
        updateValue(formValues);
      }
    }
  }, [control._formValues, control._names, disabled, name]);
  useIsomorphicLayoutEffect(function () {
    if (_prevControl.current !== control || !deepEqual(_prevName.current, name)) {
      _prevControl.current = control;
      _prevName.current = name;
      refreshValue();
    }
    return control._subscribe({
      name: name,
      formState: {
        values: true
      },
      exact: exact,
      callback: function callback(formState) {
        refreshValue(formState.values);
      }
    });
  }, [control, exact, name, refreshValue]);
  React.useEffect(function () {
    return control._removeUnmounted();
  });
  // If name or control changed for this render, synchronously reflect the
  // latest value so callers (like useController) see the correct value
  // immediately on the same render.
  // Optimize: Check control reference first before expensive deepEqual
  var controlChanged = _prevControl.current !== control;
  var prevName = _prevName.current;
  // Cache the computed output to avoid duplicate calls within the same render
  // We include shouldReturnImmediate in deps to ensure proper recomputation
  var computedOutput = React.useMemo(function () {
    if (disabled) {
      return null;
    }
    var nameChanged = !controlChanged && !deepEqual(prevName, name);
    var shouldReturnImmediate = controlChanged || nameChanged;
    return shouldReturnImmediate ? getCurrentOutput() : null;
  }, [disabled, controlChanged, name, prevName, getCurrentOutput]);
  return computedOutput !== null ? computedOutput : value;
}

/**
 * Custom hook to work with controlled component, this function provide you with both form and field level state. Re-render is isolated at the hook level.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller) • [Demo](https://codesandbox.io/s/usecontroller-0o8px)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns field properties, field and form state. {@link UseControllerReturn}
 *
 * @example
 * ```tsx
 * function Input(props) {
 *   const { field, fieldState, formState } = useController(props);
 *   return (
 *     <div>
 *       <input {...field} placeholder={props.name} />
 *       <p>{fieldState.isTouched && "Touched"}</p>
 *       <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *     </div>
 *   );
 * }
 * ```
 */
function useController(props) {
  var methods = useFormContext();
  var name = props.name,
    disabled = props.disabled,
    _props$control = props.control,
    control = _props$control === void 0 ? methods.control : _props$control,
    shouldUnregister = props.shouldUnregister,
    defaultValue = props.defaultValue;
  var isArrayField = isNameInFieldArray(control._names.array, name);
  var defaultValueMemo = React.useMemo(function () {
    return _get(control._formValues, name, _get(control._defaultValues, name, defaultValue));
  }, [control, name, defaultValue]);
  var value = useWatch({
    control: control,
    name: name,
    defaultValue: defaultValueMemo,
    exact: true
  });
  var formState = useFormState({
    control: control,
    name: name,
    exact: true
  });
  var _props = React.useRef(props);
  var _previousNameRef = React.useRef(undefined);
  var _registerProps = React.useRef(control.register(name, _objectSpread(_objectSpread({}, props.rules), {}, {
    value: value
  }, isBoolean(props.disabled) ? {
    disabled: props.disabled
  } : {})));
  _props.current = props;
  var fieldState = React.useMemo(function () {
    return Object.defineProperties({}, {
      invalid: {
        enumerable: true,
        get: function get() {
          return !!_get(formState.errors, name);
        }
      },
      isDirty: {
        enumerable: true,
        get: function get() {
          return !!_get(formState.dirtyFields, name);
        }
      },
      isTouched: {
        enumerable: true,
        get: function get() {
          return !!_get(formState.touchedFields, name);
        }
      },
      isValidating: {
        enumerable: true,
        get: function get() {
          return !!_get(formState.validatingFields, name);
        }
      },
      error: {
        enumerable: true,
        get: function get() {
          return _get(formState.errors, name);
        }
      }
    });
  }, [formState, name]);
  var onChange = React.useCallback(function (event) {
    return _registerProps.current.onChange({
      target: {
        value: getEventValue(event),
        name: name
      },
      type: EVENTS.CHANGE
    });
  }, [name]);
  var onBlur = React.useCallback(function () {
    return _registerProps.current.onBlur({
      target: {
        value: _get(control._formValues, name),
        name: name
      },
      type: EVENTS.BLUR
    });
  }, [name, control._formValues]);
  var ref = React.useCallback(function (elm) {
    var field = _get(control._fields, name);
    if (field && elm) {
      field._f.ref = {
        focus: function focus() {
          return elm.focus && elm.focus();
        },
        select: function select() {
          return elm.select && elm.select();
        },
        setCustomValidity: function setCustomValidity(message) {
          return elm.setCustomValidity(message);
        },
        reportValidity: function reportValidity() {
          return elm.reportValidity();
        }
      };
    }
  }, [control._fields, name]);
  var field = React.useMemo(function () {
    return _objectSpread(_objectSpread({
      name: name,
      value: value
    }, isBoolean(disabled) || formState.disabled ? {
      disabled: formState.disabled || disabled
    } : {}), {}, {
      onChange: onChange,
      onBlur: onBlur,
      ref: ref
    });
  }, [name, disabled, formState.disabled, onChange, onBlur, ref, value]);
  React.useEffect(function () {
    var _shouldUnregisterField = control._options.shouldUnregister || shouldUnregister;
    var previousName = _previousNameRef.current;
    if (previousName && previousName !== name && !isArrayField) {
      control.unregister(previousName);
    }
    control.register(name, _objectSpread(_objectSpread({}, _props.current.rules), isBoolean(_props.current.disabled) ? {
      disabled: _props.current.disabled
    } : {}));
    var updateMounted = function updateMounted(name, value) {
      var field = _get(control._fields, name);
      if (field && field._f) {
        field._f.mount = value;
      }
    };
    updateMounted(name, true);
    if (_shouldUnregisterField) {
      var _value = cloneObject(_get(control._options.defaultValues, name, _props.current.defaultValue));
      set(control._defaultValues, name, _value);
      if (isUndefined(_get(control._formValues, name))) {
        set(control._formValues, name, _value);
      }
    }
    !isArrayField && control.register(name);
    _previousNameRef.current = name;
    return function () {
      (isArrayField ? _shouldUnregisterField && !control._state.action : _shouldUnregisterField) ? control.unregister(name) : updateMounted(name, false);
    };
  }, [name, control, isArrayField, shouldUnregister]);
  React.useEffect(function () {
    control._setDisabledField({
      disabled: disabled,
      name: name
    });
  }, [disabled, name, control]);
  return React.useMemo(function () {
    return {
      field: field,
      formState: formState,
      fieldState: fieldState
    };
  }, [field, formState, fieldState]);
}

/**
 * Component based on `useController` hook to work with controlled component.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller/controller) • [Demo](https://codesandbox.io/s/react-hook-form-v6-controller-ts-jwyzw) • [Video](https://www.youtube.com/watch?v=N2UNk_UCVyA)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns provide field handler functions, field and form state.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control } = useForm<FormValues>({
 *     defaultValues: {
 *       test: ""
 *     }
 *   });
 *
 *   return (
 *     <form>
 *       <Controller
 *         control={control}
 *         name="test"
 *         render={({ field: { onChange, onBlur, value, ref }, formState, fieldState }) => (
 *           <>
 *             <input
 *               onChange={onChange} // send value to hook form
 *               onBlur={onBlur} // notify when input is touched
 *               value={value} // return updated value
 *               ref={ref} // set ref for focus management
 *             />
 *             <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *             <p>{fieldState.isTouched ? "touched" : ""}</p>
 *           </>
 *         )}
 *       />
 *     </form>
 *   );
 * }
 * ```
 */
var Controller = function Controller(props) {
  return props.render(useController(props));
};
var _flatten = function flatten(obj) {
  var output = {};
  for (var _i2 = 0, _Object$keys = Object.keys(obj); _i2 < _Object$keys.length; _i2++) {
    var key = _Object$keys[_i2];
    if (isObjectType(obj[key]) && obj[key] !== null) {
      var nested = _flatten(obj[key]);
      for (var _i3 = 0, _Object$keys2 = Object.keys(nested); _i3 < _Object$keys2.length; _i3++) {
        var nestedKey = _Object$keys2[_i3];
        output["".concat(key, ".").concat(nestedKey)] = nested[nestedKey];
      }
    } else {
      output[key] = obj[key];
    }
  }
  return output;
};
var POST_REQUEST = 'post';
/**
 * Form component to manage submission.
 *
 * @param props - to setup submission detail. {@link FormProps}
 *
 * @returns form component or headless render prop.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control, formState: { errors } } = useForm();
 *
 *   return (
 *     <Form action="/api" control={control}>
 *       <input {...register("name")} />
 *       <p>{errors?.root?.server && 'Server error'}</p>
 *       <button>Submit</button>
 *     </Form>
 *   );
 * }
 * ```
 */
function Form(props) {
  var methods = useFormContext();
  var _React$useState5 = React.useState(false),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    mounted = _React$useState6[0],
    setMounted = _React$useState6[1];
  var _props$control2 = props.control,
    control = _props$control2 === void 0 ? methods.control : _props$control2,
    onSubmit = props.onSubmit,
    children = props.children,
    action = props.action,
    _props$method = props.method,
    method = _props$method === void 0 ? POST_REQUEST : _props$method,
    headers = props.headers,
    encType = props.encType,
    onError = props.onError,
    render = props.render,
    onSuccess = props.onSuccess,
    validateStatus = props.validateStatus,
    rest = _objectWithoutProperties(props, _excluded2);
  var submit = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(event) {
      var hasError, type;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            hasError = false;
            type = '';
            _context2.next = 4;
            return control.handleSubmit(/*#__PURE__*/function () {
              var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(data) {
                var formData, formDataJson, flattenFormValues, key, shouldStringifySubmissionData, response;
                return _regeneratorRuntime().wrap(function _callee$(_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      formData = new FormData();
                      formDataJson = '';
                      try {
                        formDataJson = JSON.stringify(data);
                      } catch (_a) {}
                      flattenFormValues = _flatten(control._formValues);
                      for (key in flattenFormValues) {
                        formData.append(key, flattenFormValues[key]);
                      }
                      if (!onSubmit) {
                        _context.next = 8;
                        break;
                      }
                      _context.next = 8;
                      return onSubmit({
                        data: data,
                        event: event,
                        method: method,
                        formData: formData,
                        formDataJson: formDataJson
                      });
                    case 8:
                      if (!action) {
                        _context.next = 21;
                        break;
                      }
                      _context.prev = 9;
                      shouldStringifySubmissionData = [headers && headers['Content-Type'], encType].some(function (value) {
                        return value && value.includes('json');
                      });
                      _context.next = 13;
                      return fetch(String(action), {
                        method: method,
                        headers: _objectSpread(_objectSpread({}, headers), encType && encType !== 'multipart/form-data' ? {
                          'Content-Type': encType
                        } : {}),
                        body: shouldStringifySubmissionData ? formDataJson : formData
                      });
                    case 13:
                      response = _context.sent;
                      if (response && (validateStatus ? !validateStatus(response.status) : response.status < 200 || response.status >= 300)) {
                        hasError = true;
                        onError && onError({
                          response: response
                        });
                        type = String(response.status);
                      } else {
                        onSuccess && onSuccess({
                          response: response
                        });
                      }
                      _context.next = 21;
                      break;
                    case 17:
                      _context.prev = 17;
                      _context.t0 = _context["catch"](9);
                      hasError = true;
                      onError && onError({
                        error: _context.t0
                      });
                    case 21:
                    case "end":
                      return _context.stop();
                  }
                }, _callee, null, [[9, 17]]);
              }));
              return function (_x2) {
                return _ref4.apply(this, arguments);
              };
            }())(event);
          case 4:
            if (hasError && props.control) {
              props.control._subjects.state.next({
                isSubmitSuccessful: false
              });
              props.control.setError('root.server', {
                type: type
              });
            }
          case 5:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function submit(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  React.useEffect(function () {
    setMounted(true);
  }, []);
  return render ? (/*#__PURE__*/React.createElement(React.Fragment, null, render({
    submit: submit
  }))) : (/*#__PURE__*/React.createElement("form", _objectSpread({
    noValidate: mounted,
    action: action,
    method: method,
    encType: encType,
    onSubmit: submit
  }, rest), children));
}
var appendErrors = function appendErrors(name, validateAllFieldCriteria, errors, type, message) {
  return validateAllFieldCriteria ? _objectSpread(_objectSpread({}, errors[name]), {}, {
    types: _objectSpread(_objectSpread({}, errors[name] && errors[name].types ? errors[name].types : {}), {}, _defineProperty({}, type, message || true))
  }) : {};
};
var convertToArrayPayload = function convertToArrayPayload(value) {
  return Array.isArray(value) ? value : [value];
};
var createSubject = function createSubject() {
  var _observers = [];
  var next = function next(value) {
    var _iterator = _createForOfIteratorHelper(_observers),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var observer = _step.value;
        observer.next && observer.next(value);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  };
  var subscribe = function subscribe(observer) {
    _observers.push(observer);
    return {
      unsubscribe: function unsubscribe() {
        _observers = _observers.filter(function (o) {
          return o !== observer;
        });
      }
    };
  };
  var unsubscribe = function unsubscribe() {
    _observers = [];
  };
  return {
    get observers() {
      return _observers;
    },
    next: next,
    subscribe: subscribe,
    unsubscribe: unsubscribe
  };
};
function extractFormValues(fieldsState, formValues) {
  var values = {};
  for (var key in fieldsState) {
    if (fieldsState.hasOwnProperty(key)) {
      var fieldState = fieldsState[key];
      var fieldValue = formValues[key];
      if (fieldState && isObject(fieldState) && fieldValue) {
        var nestedFieldsState = extractFormValues(fieldState, fieldValue);
        if (isObject(nestedFieldsState)) {
          values[key] = nestedFieldsState;
        }
      } else if (fieldsState[key]) {
        values[key] = fieldValue;
      }
    }
  }
  return values;
}
var isEmptyObject = function isEmptyObject(value) {
  return isObject(value) && !Object.keys(value).length;
};
var isFileInput = function isFileInput(element) {
  return element.type === 'file';
};
var isFunction = function isFunction(value) {
  return typeof value === 'function';
};
var isHTMLElement = function isHTMLElement(value) {
  if (!isWeb) {
    return false;
  }
  var owner = value ? value.ownerDocument : 0;
  return value instanceof (owner && owner.defaultView ? owner.defaultView.HTMLElement : HTMLElement);
};
var isMultipleSelect = function isMultipleSelect(element) {
  return element.type === "select-multiple";
};
var isRadioInput = function isRadioInput(element) {
  return element.type === 'radio';
};
var isRadioOrCheckbox = function isRadioOrCheckbox(ref) {
  return isRadioInput(ref) || isCheckBoxInput(ref);
};
var live = function live(ref) {
  return isHTMLElement(ref) && ref.isConnected;
};
function baseGet(object, updatePath) {
  var length = updatePath.slice(0, -1).length;
  var index = 0;
  while (index < length) {
    object = isUndefined(object) ? index++ : object[updatePath[index++]];
  }
  return object;
}
function isEmptyArray(obj) {
  for (var key in obj) {
    if (obj.hasOwnProperty(key) && !isUndefined(obj[key])) {
      return false;
    }
  }
  return true;
}
function unset(object, path) {
  var paths = Array.isArray(path) ? path : isKey(path) ? [path] : stringToPath(path);
  var childObject = paths.length === 1 ? object : baseGet(object, paths);
  var index = paths.length - 1;
  var key = paths[index];
  if (childObject) {
    delete childObject[key];
  }
  if (index !== 0 && (isObject(childObject) && isEmptyObject(childObject) || Array.isArray(childObject) && isEmptyArray(childObject))) {
    unset(object, paths.slice(0, -1));
  }
  return object;
}
var objectHasFunction = function objectHasFunction(data) {
  for (var key in data) {
    if (isFunction(data[key])) {
      return true;
    }
  }
  return false;
};
function isTraversable(value) {
  return Array.isArray(value) || isObject(value) && !objectHasFunction(value);
}
function markFieldsDirty(data) {
  var fields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  for (var key in data) {
    if (isTraversable(data[key])) {
      fields[key] = Array.isArray(data[key]) ? [] : {};
      markFieldsDirty(data[key], fields[key]);
    } else if (!isUndefined(data[key])) {
      fields[key] = true;
    }
  }
  return fields;
}
function getDirtyFields(data, formValues, dirtyFieldsFromValues) {
  if (!dirtyFieldsFromValues) {
    dirtyFieldsFromValues = markFieldsDirty(formValues);
  }
  for (var key in data) {
    if (isTraversable(data[key])) {
      if (isUndefined(formValues) || isPrimitive(dirtyFieldsFromValues[key])) {
        dirtyFieldsFromValues[key] = markFieldsDirty(data[key], Array.isArray(data[key]) ? [] : {});
      } else {
        getDirtyFields(data[key], isNullOrUndefined(formValues) ? {} : formValues[key], dirtyFieldsFromValues[key]);
      }
    } else {
      dirtyFieldsFromValues[key] = !deepEqual(data[key], formValues[key]);
    }
  }
  return dirtyFieldsFromValues;
}
var defaultResult = {
  value: false,
  isValid: false
};
var validResult = {
  value: true,
  isValid: true
};
var getCheckboxValue = function getCheckboxValue(options) {
  if (Array.isArray(options)) {
    if (options.length > 1) {
      var values = options.filter(function (option) {
        return option && option.checked && !option.disabled;
      }).map(function (option) {
        return option.value;
      });
      return {
        value: values,
        isValid: !!values.length
      };
    }
    return options[0].checked && !options[0].disabled ?
    // @ts-expect-error expected to work in the browser
    options[0].attributes && !isUndefined(options[0].attributes.value) ? isUndefined(options[0].value) || options[0].value === '' ? validResult : {
      value: options[0].value,
      isValid: true
    } : validResult : defaultResult;
  }
  return defaultResult;
};
var getFieldValueAs = function getFieldValueAs(value, _ref5) {
  var valueAsNumber = _ref5.valueAsNumber,
    valueAsDate = _ref5.valueAsDate,
    setValueAs = _ref5.setValueAs;
  return isUndefined(value) ? value : valueAsNumber ? value === '' ? NaN : value ? +value : value : valueAsDate && isString(value) ? new Date(value) : setValueAs ? setValueAs(value) : value;
};
var defaultReturn = {
  isValid: false,
  value: null
};
var getRadioValue = function getRadioValue(options) {
  return Array.isArray(options) ? options.reduce(function (previous, option) {
    return option && option.checked && !option.disabled ? {
      isValid: true,
      value: option.value
    } : previous;
  }, defaultReturn) : defaultReturn;
};
function getFieldValue(_f) {
  var ref = _f.ref;
  if (isFileInput(ref)) {
    return ref.files;
  }
  if (isRadioInput(ref)) {
    return getRadioValue(_f.refs).value;
  }
  if (isMultipleSelect(ref)) {
    return _toConsumableArray(ref.selectedOptions).map(function (_ref6) {
      var value = _ref6.value;
      return value;
    });
  }
  if (isCheckBoxInput(ref)) {
    return getCheckboxValue(_f.refs).value;
  }
  return getFieldValueAs(isUndefined(ref.value) ? _f.ref.value : ref.value, _f);
}
var getResolverOptions = function getResolverOptions(fieldsNames, _fields, criteriaMode, shouldUseNativeValidation) {
  var fields = {};
  var _iterator2 = _createForOfIteratorHelper(fieldsNames),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var name = _step2.value;
      var field = _get(_fields, name);
      field && set(fields, name, field._f);
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return {
    criteriaMode: criteriaMode,
    names: _toConsumableArray(fieldsNames),
    fields: fields,
    shouldUseNativeValidation: shouldUseNativeValidation
  };
};
var isRegex = function isRegex(value) {
  return value instanceof RegExp;
};
var getRuleValue = function getRuleValue(rule) {
  return isUndefined(rule) ? rule : isRegex(rule) ? rule.source : isObject(rule) ? isRegex(rule.value) ? rule.value.source : rule.value : rule;
};
var getValidationModes = function getValidationModes(mode) {
  return {
    isOnSubmit: !mode || mode === VALIDATION_MODE.onSubmit,
    isOnBlur: mode === VALIDATION_MODE.onBlur,
    isOnChange: mode === VALIDATION_MODE.onChange,
    isOnAll: mode === VALIDATION_MODE.all,
    isOnTouch: mode === VALIDATION_MODE.onTouched
  };
};
var ASYNC_FUNCTION = 'AsyncFunction';
var hasPromiseValidation = function hasPromiseValidation(fieldReference) {
  return !!fieldReference && !!fieldReference.validate && !!(isFunction(fieldReference.validate) && fieldReference.validate.constructor.name === ASYNC_FUNCTION || isObject(fieldReference.validate) && Object.values(fieldReference.validate).find(function (validateFunction) {
    return validateFunction.constructor.name === ASYNC_FUNCTION;
  }));
};
var hasValidation = function hasValidation(options) {
  return options.mount && (options.required || options.min || options.max || options.maxLength || options.minLength || options.pattern || options.validate);
};
var isWatched = function isWatched(name, _names, isBlurEvent) {
  return !isBlurEvent && (_names.watchAll || _names.watch.has(name) || _toConsumableArray(_names.watch).some(function (watchName) {
    return name.startsWith(watchName) && /^\.\w+/.test(name.slice(watchName.length));
  }));
};
var _iterateFieldsByAction = function iterateFieldsByAction(fields, action, fieldsNames, abortEarly) {
  var _iterator3 = _createForOfIteratorHelper(fieldsNames || Object.keys(fields)),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var key = _step3.value;
      var field = _get(fields, key);
      if (field) {
        var _f = field._f,
          currentField = _objectWithoutProperties(field, _excluded3);
        if (_f) {
          if (_f.refs && _f.refs[0] && action(_f.refs[0], key) && !abortEarly) {
            return true;
          } else if (_f.ref && action(_f.ref, _f.name) && !abortEarly) {
            return true;
          } else {
            if (_iterateFieldsByAction(currentField, action)) {
              break;
            }
          }
        } else if (isObject(currentField)) {
          if (_iterateFieldsByAction(currentField, action)) {
            break;
          }
        }
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  return;
};
function schemaErrorLookup(errors, _fields, name) {
  var error = _get(errors, name);
  if (error || isKey(name)) {
    return {
      error: error,
      name: name
    };
  }
  var names = name.split('.');
  while (names.length) {
    var fieldName = names.join('.');
    var field = _get(_fields, fieldName);
    var foundError = _get(errors, fieldName);
    if (field && !Array.isArray(field) && name !== fieldName) {
      return {
        name: name
      };
    }
    if (foundError && foundError.type) {
      return {
        name: fieldName,
        error: foundError
      };
    }
    if (foundError && foundError.root && foundError.root.type) {
      return {
        name: "".concat(fieldName, ".root"),
        error: foundError.root
      };
    }
    names.pop();
  }
  return {
    name: name
  };
}
var shouldRenderFormState = function shouldRenderFormState(formStateData, _proxyFormState, updateFormState, isRoot) {
  updateFormState(formStateData);
  var name = formStateData.name,
    formState = _objectWithoutProperties(formStateData, _excluded4);
  return isEmptyObject(formState) || Object.keys(formState).length >= Object.keys(_proxyFormState).length || Object.keys(formState).find(function (key) {
    return _proxyFormState[key] === (!isRoot || VALIDATION_MODE.all);
  });
};
var shouldSubscribeByName = function shouldSubscribeByName(name, signalName, exact) {
  return !name || !signalName || name === signalName || convertToArrayPayload(name).some(function (currentName) {
    return currentName && (exact ? currentName === signalName : currentName.startsWith(signalName) || signalName.startsWith(currentName));
  });
};
var skipValidation = function skipValidation(isBlurEvent, isTouched, isSubmitted, reValidateMode, mode) {
  if (mode.isOnAll) {
    return false;
  } else if (!isSubmitted && mode.isOnTouch) {
    return !(isTouched || isBlurEvent);
  } else if (isSubmitted ? reValidateMode.isOnBlur : mode.isOnBlur) {
    return !isBlurEvent;
  } else if (isSubmitted ? reValidateMode.isOnChange : mode.isOnChange) {
    return isBlurEvent;
  }
  return true;
};
var unsetEmptyArray = function unsetEmptyArray(ref, name) {
  return !compact(_get(ref, name)).length && unset(ref, name);
};
var updateFieldArrayRootError = function updateFieldArrayRootError(errors, error, name) {
  var fieldArrayErrors = convertToArrayPayload(_get(errors, name));
  set(fieldArrayErrors, 'root', error[name]);
  set(errors, name, fieldArrayErrors);
  return errors;
};
function getValidateError(result, ref) {
  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'validate';
  if (isString(result) || Array.isArray(result) && result.every(isString) || isBoolean(result) && !result) {
    return {
      type: type,
      message: isString(result) ? result : '',
      ref: ref
    };
  }
}
var getValueAndMessage = function getValueAndMessage(validationData) {
  return isObject(validationData) && !isRegex(validationData) ? validationData : {
    value: validationData,
    message: ''
  };
};
var validateField = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(field, disabledFieldNames, formValues, validateAllFieldCriteria, shouldUseNativeValidation, isFieldArray) {
    var _field$_f, ref, refs, required, maxLength, minLength, min, max, pattern, validate, name, valueAsNumber, mount, inputValue, inputRef, setCustomValidity, error, isRadio, isCheckBox, isRadioOrCheckbox, isEmpty, appendErrorsCurry, getMinMaxMessage, _ref8, value, message, exceedMax, exceedMin, maxOutput, minOutput, valueNumber, valueDate, convertTimeToDate, isTime, isWeek, maxLengthOutput, minLengthOutput, _exceedMax, _exceedMin, _getValueAndMessage, patternValue, _message, result, validateError, validationResult, key, _validateError;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _field$_f = field._f, ref = _field$_f.ref, refs = _field$_f.refs, required = _field$_f.required, maxLength = _field$_f.maxLength, minLength = _field$_f.minLength, min = _field$_f.min, max = _field$_f.max, pattern = _field$_f.pattern, validate = _field$_f.validate, name = _field$_f.name, valueAsNumber = _field$_f.valueAsNumber, mount = _field$_f.mount;
          inputValue = _get(formValues, name);
          if (!(!mount || disabledFieldNames.has(name))) {
            _context3.next = 4;
            break;
          }
          return _context3.abrupt("return", {});
        case 4:
          inputRef = refs ? refs[0] : ref;
          setCustomValidity = function setCustomValidity(message) {
            if (shouldUseNativeValidation && inputRef.reportValidity) {
              inputRef.setCustomValidity(isBoolean(message) ? '' : message || '');
              inputRef.reportValidity();
            }
          };
          error = {};
          isRadio = isRadioInput(ref);
          isCheckBox = isCheckBoxInput(ref);
          isRadioOrCheckbox = isRadio || isCheckBox;
          isEmpty = (valueAsNumber || isFileInput(ref)) && isUndefined(ref.value) && isUndefined(inputValue) || isHTMLElement(ref) && ref.value === '' || inputValue === '' || Array.isArray(inputValue) && !inputValue.length;
          appendErrorsCurry = appendErrors.bind(null, name, validateAllFieldCriteria, error);
          getMinMaxMessage = function getMinMaxMessage(exceedMax, maxLengthMessage, minLengthMessage) {
            var maxType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : INPUT_VALIDATION_RULES.maxLength;
            var minType = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : INPUT_VALIDATION_RULES.minLength;
            var message = exceedMax ? maxLengthMessage : minLengthMessage;
            error[name] = _objectSpread({
              type: exceedMax ? maxType : minType,
              message: message,
              ref: ref
            }, appendErrorsCurry(exceedMax ? maxType : minType, message));
          };
          if (!(isFieldArray ? !Array.isArray(inputValue) || !inputValue.length : required && (!isRadioOrCheckbox && (isEmpty || isNullOrUndefined(inputValue)) || isBoolean(inputValue) && !inputValue || isCheckBox && !getCheckboxValue(refs).isValid || isRadio && !getRadioValue(refs).isValid))) {
            _context3.next = 20;
            break;
          }
          _ref8 = isString(required) ? {
            value: !!required,
            message: required
          } : getValueAndMessage(required), value = _ref8.value, message = _ref8.message;
          if (!value) {
            _context3.next = 20;
            break;
          }
          error[name] = _objectSpread({
            type: INPUT_VALIDATION_RULES.required,
            message: message,
            ref: inputRef
          }, appendErrorsCurry(INPUT_VALIDATION_RULES.required, message));
          if (validateAllFieldCriteria) {
            _context3.next = 20;
            break;
          }
          setCustomValidity(message);
          return _context3.abrupt("return", error);
        case 20:
          if (!(!isEmpty && (!isNullOrUndefined(min) || !isNullOrUndefined(max)))) {
            _context3.next = 29;
            break;
          }
          maxOutput = getValueAndMessage(max);
          minOutput = getValueAndMessage(min);
          if (!isNullOrUndefined(inputValue) && !isNaN(inputValue)) {
            valueNumber = ref.valueAsNumber || (inputValue ? +inputValue : inputValue);
            if (!isNullOrUndefined(maxOutput.value)) {
              exceedMax = valueNumber > maxOutput.value;
            }
            if (!isNullOrUndefined(minOutput.value)) {
              exceedMin = valueNumber < minOutput.value;
            }
          } else {
            valueDate = ref.valueAsDate || new Date(inputValue);
            convertTimeToDate = function convertTimeToDate(time) {
              return new Date(new Date().toDateString() + ' ' + time);
            };
            isTime = ref.type == 'time';
            isWeek = ref.type == 'week';
            if (isString(maxOutput.value) && inputValue) {
              exceedMax = isTime ? convertTimeToDate(inputValue) > convertTimeToDate(maxOutput.value) : isWeek ? inputValue > maxOutput.value : valueDate > new Date(maxOutput.value);
            }
            if (isString(minOutput.value) && inputValue) {
              exceedMin = isTime ? convertTimeToDate(inputValue) < convertTimeToDate(minOutput.value) : isWeek ? inputValue < minOutput.value : valueDate < new Date(minOutput.value);
            }
          }
          if (!(exceedMax || exceedMin)) {
            _context3.next = 29;
            break;
          }
          getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, INPUT_VALIDATION_RULES.max, INPUT_VALIDATION_RULES.min);
          if (validateAllFieldCriteria) {
            _context3.next = 29;
            break;
          }
          setCustomValidity(error[name].message);
          return _context3.abrupt("return", error);
        case 29:
          if (!((maxLength || minLength) && !isEmpty && (isString(inputValue) || isFieldArray && Array.isArray(inputValue)))) {
            _context3.next = 39;
            break;
          }
          maxLengthOutput = getValueAndMessage(maxLength);
          minLengthOutput = getValueAndMessage(minLength);
          _exceedMax = !isNullOrUndefined(maxLengthOutput.value) && inputValue.length > +maxLengthOutput.value;
          _exceedMin = !isNullOrUndefined(minLengthOutput.value) && inputValue.length < +minLengthOutput.value;
          if (!(_exceedMax || _exceedMin)) {
            _context3.next = 39;
            break;
          }
          getMinMaxMessage(_exceedMax, maxLengthOutput.message, minLengthOutput.message);
          if (validateAllFieldCriteria) {
            _context3.next = 39;
            break;
          }
          setCustomValidity(error[name].message);
          return _context3.abrupt("return", error);
        case 39:
          if (!(pattern && !isEmpty && isString(inputValue))) {
            _context3.next = 46;
            break;
          }
          _getValueAndMessage = getValueAndMessage(pattern), patternValue = _getValueAndMessage.value, _message = _getValueAndMessage.message;
          if (!(isRegex(patternValue) && !inputValue.match(patternValue))) {
            _context3.next = 46;
            break;
          }
          error[name] = _objectSpread({
            type: INPUT_VALIDATION_RULES.pattern,
            message: _message,
            ref: ref
          }, appendErrorsCurry(INPUT_VALIDATION_RULES.pattern, _message));
          if (validateAllFieldCriteria) {
            _context3.next = 46;
            break;
          }
          setCustomValidity(_message);
          return _context3.abrupt("return", error);
        case 46:
          if (!validate) {
            _context3.next = 80;
            break;
          }
          if (!isFunction(validate)) {
            _context3.next = 59;
            break;
          }
          _context3.next = 50;
          return validate(inputValue, formValues);
        case 50:
          result = _context3.sent;
          validateError = getValidateError(result, inputRef);
          if (!validateError) {
            _context3.next = 57;
            break;
          }
          error[name] = _objectSpread(_objectSpread({}, validateError), appendErrorsCurry(INPUT_VALIDATION_RULES.validate, validateError.message));
          if (validateAllFieldCriteria) {
            _context3.next = 57;
            break;
          }
          setCustomValidity(validateError.message);
          return _context3.abrupt("return", error);
        case 57:
          _context3.next = 80;
          break;
        case 59:
          if (!isObject(validate)) {
            _context3.next = 80;
            break;
          }
          validationResult = {};
          _context3.t0 = _regeneratorRuntime().keys(validate);
        case 62:
          if ((_context3.t1 = _context3.t0()).done) {
            _context3.next = 76;
            break;
          }
          key = _context3.t1.value;
          if (!(!isEmptyObject(validationResult) && !validateAllFieldCriteria)) {
            _context3.next = 66;
            break;
          }
          return _context3.abrupt("break", 76);
        case 66:
          _context3.t2 = getValidateError;
          _context3.next = 69;
          return validate[key](inputValue, formValues);
        case 69:
          _context3.t3 = _context3.sent;
          _context3.t4 = inputRef;
          _context3.t5 = key;
          _validateError = (0, _context3.t2)(_context3.t3, _context3.t4, _context3.t5);
          if (_validateError) {
            validationResult = _objectSpread(_objectSpread({}, _validateError), appendErrorsCurry(key, _validateError.message));
            setCustomValidity(_validateError.message);
            if (validateAllFieldCriteria) {
              error[name] = validationResult;
            }
          }
          _context3.next = 62;
          break;
        case 76:
          if (isEmptyObject(validationResult)) {
            _context3.next = 80;
            break;
          }
          error[name] = _objectSpread({
            ref: inputRef
          }, validationResult);
          if (validateAllFieldCriteria) {
            _context3.next = 80;
            break;
          }
          return _context3.abrupt("return", error);
        case 80:
          setCustomValidity(true);
          return _context3.abrupt("return", error);
        case 82:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function validateField(_x3, _x4, _x5, _x6, _x7, _x8) {
    return _ref7.apply(this, arguments);
  };
}();
var defaultOptions = {
  mode: VALIDATION_MODE.onSubmit,
  reValidateMode: VALIDATION_MODE.onChange,
  shouldFocusError: true
};
function createFormControl() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options = _objectSpread(_objectSpread({}, defaultOptions), props);
  var _formState = {
    submitCount: 0,
    isDirty: false,
    isReady: false,
    isLoading: isFunction(_options.defaultValues),
    isValidating: false,
    isSubmitted: false,
    isSubmitting: false,
    isSubmitSuccessful: false,
    isValid: false,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: _options.errors || {},
    disabled: _options.disabled || false
  };
  var _fields = {};
  var _defaultValues = isObject(_options.defaultValues) || isObject(_options.values) ? cloneObject(_options.defaultValues || _options.values) || {} : {};
  var _formValues = _options.shouldUnregister ? {} : cloneObject(_defaultValues);
  var _state = {
    action: false,
    mount: false,
    watch: false
  };
  var _names = {
    mount: new Set(),
    disabled: new Set(),
    unMount: new Set(),
    array: new Set(),
    watch: new Set()
  };
  var delayErrorCallback;
  var timer = 0;
  var _proxyFormState = {
    isDirty: false,
    dirtyFields: false,
    validatingFields: false,
    touchedFields: false,
    isValidating: false,
    isValid: false,
    errors: false
  };
  var _proxySubscribeFormState = _objectSpread({}, _proxyFormState);
  var _subjects = {
    array: createSubject(),
    state: createSubject()
  };
  var shouldDisplayAllAssociatedErrors = _options.criteriaMode === VALIDATION_MODE.all;
  var debounce = function debounce(callback) {
    return function (wait) {
      clearTimeout(timer);
      timer = setTimeout(callback, wait);
    };
  };
  var _setValid = /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(shouldUpdateValid) {
      var isValid;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            if (!(!_options.disabled && (_proxyFormState.isValid || _proxySubscribeFormState.isValid || shouldUpdateValid))) {
              _context4.next = 14;
              break;
            }
            if (!_options.resolver) {
              _context4.next = 9;
              break;
            }
            _context4.t1 = isEmptyObject;
            _context4.next = 5;
            return _runSchema();
          case 5:
            _context4.t2 = _context4.sent.errors;
            _context4.t0 = (0, _context4.t1)(_context4.t2);
            _context4.next = 12;
            break;
          case 9:
            _context4.next = 11;
            return _executeBuiltInValidation(_fields, true);
          case 11:
            _context4.t0 = _context4.sent;
          case 12:
            isValid = _context4.t0;
            if (isValid !== _formState.isValid) {
              _subjects.state.next({
                isValid: isValid
              });
            }
          case 14:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function _setValid(_x9) {
      return _ref9.apply(this, arguments);
    };
  }();
  var _updateIsValidating = function _updateIsValidating(names, isValidating) {
    if (!_options.disabled && (_proxyFormState.isValidating || _proxyFormState.validatingFields || _proxySubscribeFormState.isValidating || _proxySubscribeFormState.validatingFields)) {
      (names || Array.from(_names.mount)).forEach(function (name) {
        if (name) {
          isValidating ? set(_formState.validatingFields, name, isValidating) : unset(_formState.validatingFields, name);
        }
      });
      _subjects.state.next({
        validatingFields: _formState.validatingFields,
        isValidating: !isEmptyObject(_formState.validatingFields)
      });
    }
  };
  var _setFieldArray = function _setFieldArray(name) {
    var values = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var method = arguments.length > 2 ? arguments[2] : undefined;
    var args = arguments.length > 3 ? arguments[3] : undefined;
    var shouldSetValues = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    var shouldUpdateFieldsAndState = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;
    if (args && method && !_options.disabled) {
      _state.action = true;
      if (shouldUpdateFieldsAndState && Array.isArray(_get(_fields, name))) {
        var fieldValues = method(_get(_fields, name), args.argA, args.argB);
        shouldSetValues && set(_fields, name, fieldValues);
      }
      if (shouldUpdateFieldsAndState && Array.isArray(_get(_formState.errors, name))) {
        var errors = method(_get(_formState.errors, name), args.argA, args.argB);
        shouldSetValues && set(_formState.errors, name, errors);
        unsetEmptyArray(_formState.errors, name);
      }
      if ((_proxyFormState.touchedFields || _proxySubscribeFormState.touchedFields) && shouldUpdateFieldsAndState && Array.isArray(_get(_formState.touchedFields, name))) {
        var touchedFields = method(_get(_formState.touchedFields, name), args.argA, args.argB);
        shouldSetValues && set(_formState.touchedFields, name, touchedFields);
      }
      if (_proxyFormState.dirtyFields || _proxySubscribeFormState.dirtyFields) {
        _formState.dirtyFields = getDirtyFields(_defaultValues, _formValues);
      }
      _subjects.state.next({
        name: name,
        isDirty: _getDirty(name, values),
        dirtyFields: _formState.dirtyFields,
        errors: _formState.errors,
        isValid: _formState.isValid
      });
    } else {
      set(_formValues, name, values);
    }
  };
  var updateErrors = function updateErrors(name, error) {
    set(_formState.errors, name, error);
    _subjects.state.next({
      errors: _formState.errors
    });
  };
  var _setErrors = function _setErrors(errors) {
    _formState.errors = errors;
    _subjects.state.next({
      errors: _formState.errors,
      isValid: false
    });
  };
  var updateValidAndValue = function updateValidAndValue(name, shouldSkipSetValueAs, value, ref) {
    var field = _get(_fields, name);
    if (field) {
      var defaultValue = _get(_formValues, name, isUndefined(value) ? _get(_defaultValues, name) : value);
      isUndefined(defaultValue) || ref && ref.defaultChecked || shouldSkipSetValueAs ? set(_formValues, name, shouldSkipSetValueAs ? defaultValue : getFieldValue(field._f)) : setFieldValue(name, defaultValue);
      _state.mount && _setValid();
    }
  };
  var updateTouchAndDirty = function updateTouchAndDirty(name, fieldValue, isBlurEvent, shouldDirty, shouldRender) {
    var shouldUpdateField = false;
    var isPreviousDirty = false;
    var output = {
      name: name
    };
    if (!_options.disabled) {
      if (!isBlurEvent || shouldDirty) {
        if (_proxyFormState.isDirty || _proxySubscribeFormState.isDirty) {
          isPreviousDirty = _formState.isDirty;
          _formState.isDirty = output.isDirty = _getDirty();
          shouldUpdateField = isPreviousDirty !== output.isDirty;
        }
        var isCurrentFieldPristine = deepEqual(_get(_defaultValues, name), fieldValue);
        isPreviousDirty = !!_get(_formState.dirtyFields, name);
        isCurrentFieldPristine ? unset(_formState.dirtyFields, name) : set(_formState.dirtyFields, name, true);
        output.dirtyFields = _formState.dirtyFields;
        shouldUpdateField = shouldUpdateField || (_proxyFormState.dirtyFields || _proxySubscribeFormState.dirtyFields) && isPreviousDirty !== !isCurrentFieldPristine;
      }
      if (isBlurEvent) {
        var isPreviousFieldTouched = _get(_formState.touchedFields, name);
        if (!isPreviousFieldTouched) {
          set(_formState.touchedFields, name, isBlurEvent);
          output.touchedFields = _formState.touchedFields;
          shouldUpdateField = shouldUpdateField || (_proxyFormState.touchedFields || _proxySubscribeFormState.touchedFields) && isPreviousFieldTouched !== isBlurEvent;
        }
      }
      shouldUpdateField && shouldRender && _subjects.state.next(output);
    }
    return shouldUpdateField ? output : {};
  };
  var shouldRenderByError = function shouldRenderByError(name, isValid, error, fieldState) {
    var previousFieldError = _get(_formState.errors, name);
    var shouldUpdateValid = (_proxyFormState.isValid || _proxySubscribeFormState.isValid) && isBoolean(isValid) && _formState.isValid !== isValid;
    if (_options.delayError && error) {
      delayErrorCallback = debounce(function () {
        return updateErrors(name, error);
      });
      delayErrorCallback(_options.delayError);
    } else {
      clearTimeout(timer);
      delayErrorCallback = null;
      error ? set(_formState.errors, name, error) : unset(_formState.errors, name);
    }
    if ((error ? !deepEqual(previousFieldError, error) : previousFieldError) || !isEmptyObject(fieldState) || shouldUpdateValid) {
      var updatedFormState = _objectSpread(_objectSpread(_objectSpread({}, fieldState), shouldUpdateValid && isBoolean(isValid) ? {
        isValid: isValid
      } : {}), {}, {
        errors: _formState.errors,
        name: name
      });
      _formState = _objectSpread(_objectSpread({}, _formState), updatedFormState);
      _subjects.state.next(updatedFormState);
    }
  };
  var _runSchema = /*#__PURE__*/function () {
    var _ref0 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(name) {
      var result;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _updateIsValidating(name, true);
            _context5.next = 3;
            return _options.resolver(_formValues, _options.context, getResolverOptions(name || _names.mount, _fields, _options.criteriaMode, _options.shouldUseNativeValidation));
          case 3:
            result = _context5.sent;
            _updateIsValidating(name);
            return _context5.abrupt("return", result);
          case 6:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return function _runSchema(_x0) {
      return _ref0.apply(this, arguments);
    };
  }();
  var executeSchemaAndUpdateState = /*#__PURE__*/function () {
    var _ref1 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6(names) {
      var _yield$_runSchema, errors, _iterator4, _step4, _name, _error;
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return _runSchema(names);
          case 2:
            _yield$_runSchema = _context6.sent;
            errors = _yield$_runSchema.errors;
            if (names) {
              _iterator4 = _createForOfIteratorHelper(names);
              try {
                for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                  _name = _step4.value;
                  _error = _get(errors, _name);
                  _error ? set(_formState.errors, _name, _error) : unset(_formState.errors, _name);
                }
              } catch (err) {
                _iterator4.e(err);
              } finally {
                _iterator4.f();
              }
            } else {
              _formState.errors = errors;
            }
            return _context6.abrupt("return", errors);
          case 6:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
    return function executeSchemaAndUpdateState(_x1) {
      return _ref1.apply(this, arguments);
    };
  }();
  var _executeBuiltInValidation = /*#__PURE__*/function () {
    var _ref10 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7(fields, shouldOnlyCheckValid) {
      var context,
        _name2,
        field,
        _f,
        fieldValue,
        isFieldArrayRoot,
        isPromiseFunction,
        fieldError,
        _args7 = arguments;
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            context = _args7.length > 2 && _args7[2] !== undefined ? _args7[2] : {
              valid: true
            };
            _context7.t0 = _regeneratorRuntime().keys(fields);
          case 2:
            if ((_context7.t1 = _context7.t0()).done) {
              _context7.next = 26;
              break;
            }
            _name2 = _context7.t1.value;
            field = fields[_name2];
            if (!field) {
              _context7.next = 24;
              break;
            }
            _f = field._f, fieldValue = _objectWithoutProperties(field, _excluded5);
            if (!_f) {
              _context7.next = 20;
              break;
            }
            isFieldArrayRoot = _names.array.has(_f.name);
            isPromiseFunction = field._f && hasPromiseValidation(field._f);
            if (isPromiseFunction && _proxyFormState.validatingFields) {
              _updateIsValidating([_f.name], true);
            }
            _context7.next = 13;
            return validateField(field, _names.disabled, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation && !shouldOnlyCheckValid, isFieldArrayRoot);
          case 13:
            fieldError = _context7.sent;
            if (isPromiseFunction && _proxyFormState.validatingFields) {
              _updateIsValidating([_f.name]);
            }
            if (!fieldError[_f.name]) {
              _context7.next = 19;
              break;
            }
            context.valid = false;
            if (!shouldOnlyCheckValid) {
              _context7.next = 19;
              break;
            }
            return _context7.abrupt("break", 26);
          case 19:
            !shouldOnlyCheckValid && (_get(fieldError, _f.name) ? isFieldArrayRoot ? updateFieldArrayRootError(_formState.errors, fieldError, _f.name) : set(_formState.errors, _f.name, fieldError[_f.name]) : unset(_formState.errors, _f.name));
          case 20:
            _context7.t2 = !isEmptyObject(fieldValue);
            if (!_context7.t2) {
              _context7.next = 24;
              break;
            }
            _context7.next = 24;
            return _executeBuiltInValidation(fieldValue, shouldOnlyCheckValid, context);
          case 24:
            _context7.next = 2;
            break;
          case 26:
            return _context7.abrupt("return", context.valid);
          case 27:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }));
    return function executeBuiltInValidation(_x10, _x11) {
      return _ref10.apply(this, arguments);
    };
  }();
  var _removeUnmounted = function _removeUnmounted() {
    var _iterator5 = _createForOfIteratorHelper(_names.unMount),
      _step5;
    try {
      for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
        var _name3 = _step5.value;
        var field = _get(_fields, _name3);
        field && (field._f.refs ? field._f.refs.every(function (ref) {
          return !live(ref);
        }) : !live(field._f.ref)) && unregister(_name3);
      }
    } catch (err) {
      _iterator5.e(err);
    } finally {
      _iterator5.f();
    }
    _names.unMount = new Set();
  };
  var _getDirty = function _getDirty(name, data) {
    return !_options.disabled && (name && data && set(_formValues, name, data), !deepEqual(getValues(), _defaultValues));
  };
  var _getWatch = function _getWatch(names, defaultValue, isGlobal) {
    return generateWatchOutput(names, _names, _objectSpread({}, _state.mount ? _formValues : isUndefined(defaultValue) ? _defaultValues : isString(names) ? _defineProperty({}, names, defaultValue) : defaultValue), isGlobal, defaultValue);
  };
  var _getFieldArray = function _getFieldArray(name) {
    return compact(_get(_state.mount ? _formValues : _defaultValues, name, _options.shouldUnregister ? _get(_defaultValues, name, []) : []));
  };
  var setFieldValue = function setFieldValue(name, value) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var field = _get(_fields, name);
    var fieldValue = value;
    if (field) {
      var fieldReference = field._f;
      if (fieldReference) {
        !fieldReference.disabled && set(_formValues, name, getFieldValueAs(value, fieldReference));
        fieldValue = isHTMLElement(fieldReference.ref) && isNullOrUndefined(value) ? '' : value;
        if (isMultipleSelect(fieldReference.ref)) {
          _toConsumableArray(fieldReference.ref.options).forEach(function (optionRef) {
            return optionRef.selected = fieldValue.includes(optionRef.value);
          });
        } else if (fieldReference.refs) {
          if (isCheckBoxInput(fieldReference.ref)) {
            fieldReference.refs.forEach(function (checkboxRef) {
              if (!checkboxRef.defaultChecked || !checkboxRef.disabled) {
                if (Array.isArray(fieldValue)) {
                  checkboxRef.checked = !!fieldValue.find(function (data) {
                    return data === checkboxRef.value;
                  });
                } else {
                  checkboxRef.checked = fieldValue === checkboxRef.value || !!fieldValue;
                }
              }
            });
          } else {
            fieldReference.refs.forEach(function (radioRef) {
              return radioRef.checked = radioRef.value === fieldValue;
            });
          }
        } else if (isFileInput(fieldReference.ref)) {
          fieldReference.ref.value = '';
        } else {
          fieldReference.ref.value = fieldValue;
          if (!fieldReference.ref.type) {
            _subjects.state.next({
              name: name,
              values: cloneObject(_formValues)
            });
          }
        }
      }
    }
    (options.shouldDirty || options.shouldTouch) && updateTouchAndDirty(name, fieldValue, options.shouldTouch, options.shouldDirty, true);
    options.shouldValidate && trigger(name);
  };
  var _setValues = function setValues(name, value, options) {
    for (var fieldKey in value) {
      if (!value.hasOwnProperty(fieldKey)) {
        return;
      }
      var fieldValue = value[fieldKey];
      var fieldName = name + '.' + fieldKey;
      var field = _get(_fields, fieldName);
      (_names.array.has(name) || isObject(fieldValue) || field && !field._f) && !isDateObject(fieldValue) ? _setValues(fieldName, fieldValue, options) : setFieldValue(fieldName, fieldValue, options);
    }
  };
  var setValue = function setValue(name, value) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var field = _get(_fields, name);
    var isFieldArray = _names.array.has(name);
    var cloneValue = cloneObject(value);
    set(_formValues, name, cloneValue);
    if (isFieldArray) {
      _subjects.array.next({
        name: name,
        values: cloneObject(_formValues)
      });
      if ((_proxyFormState.isDirty || _proxyFormState.dirtyFields || _proxySubscribeFormState.isDirty || _proxySubscribeFormState.dirtyFields) && options.shouldDirty) {
        _subjects.state.next({
          name: name,
          dirtyFields: getDirtyFields(_defaultValues, _formValues),
          isDirty: _getDirty(name, cloneValue)
        });
      }
    } else {
      field && !field._f && !isNullOrUndefined(cloneValue) ? _setValues(name, cloneValue, options) : setFieldValue(name, cloneValue, options);
    }
    isWatched(name, _names) && _subjects.state.next(_objectSpread(_objectSpread({}, _formState), {}, {
      name: name
    }));
    _subjects.state.next({
      name: _state.mount ? name : undefined,
      values: cloneObject(_formValues)
    });
  };
  var onChange = /*#__PURE__*/function () {
    var _ref12 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8(event) {
      var target, name, isFieldValueUpdated, field, _updateIsFieldValueUpdated, validationModeBeforeSubmit, validationModeAfterSubmit, _error2, isValid, fieldValue, isBlurEvent, shouldSkipValidation, watched, fieldState, shouldRender, _yield$_runSchema2, errors, previousErrorLookupResult, errorLookupResult;
      return _regeneratorRuntime().wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            _state.mount = true;
            target = event.target;
            name = target.name;
            isFieldValueUpdated = true;
            field = _get(_fields, name);
            _updateIsFieldValueUpdated = function _updateIsFieldValueUpdated(fieldValue) {
              isFieldValueUpdated = Number.isNaN(fieldValue) || isDateObject(fieldValue) && isNaN(fieldValue.getTime()) || deepEqual(fieldValue, _get(_formValues, name, fieldValue));
            };
            validationModeBeforeSubmit = getValidationModes(_options.mode);
            validationModeAfterSubmit = getValidationModes(_options.reValidateMode);
            if (!field) {
              _context8.next = 48;
              break;
            }
            fieldValue = target.type ? getFieldValue(field._f) : getEventValue(event);
            isBlurEvent = event.type === EVENTS.BLUR || event.type === EVENTS.FOCUS_OUT;
            shouldSkipValidation = !hasValidation(field._f) && !_options.resolver && !_get(_formState.errors, name) && !field._f.deps || skipValidation(isBlurEvent, _get(_formState.touchedFields, name), _formState.isSubmitted, validationModeAfterSubmit, validationModeBeforeSubmit);
            watched = isWatched(name, _names, isBlurEvent);
            set(_formValues, name, fieldValue);
            if (isBlurEvent) {
              if (!target || !target.readOnly) {
                field._f.onBlur && field._f.onBlur(event);
                delayErrorCallback && delayErrorCallback(0);
              }
            } else if (field._f.onChange) {
              field._f.onChange(event);
            }
            fieldState = updateTouchAndDirty(name, fieldValue, isBlurEvent);
            shouldRender = !isEmptyObject(fieldState) || watched;
            !isBlurEvent && _subjects.state.next({
              name: name,
              type: event.type,
              values: cloneObject(_formValues)
            });
            if (!shouldSkipValidation) {
              _context8.next = 21;
              break;
            }
            if (_proxyFormState.isValid || _proxySubscribeFormState.isValid) {
              if (_options.mode === 'onBlur') {
                if (isBlurEvent) {
                  _setValid();
                }
              } else if (!isBlurEvent) {
                _setValid();
              }
            }
            return _context8.abrupt("return", shouldRender && _subjects.state.next(_objectSpread({
              name: name
            }, watched ? {} : fieldState)));
          case 21:
            !isBlurEvent && watched && _subjects.state.next(_objectSpread({}, _formState));
            if (!_options.resolver) {
              _context8.next = 31;
              break;
            }
            _context8.next = 25;
            return _runSchema([name]);
          case 25:
            _yield$_runSchema2 = _context8.sent;
            errors = _yield$_runSchema2.errors;
            _updateIsFieldValueUpdated(fieldValue);
            if (isFieldValueUpdated) {
              previousErrorLookupResult = schemaErrorLookup(_formState.errors, _fields, name);
              errorLookupResult = schemaErrorLookup(errors, _fields, previousErrorLookupResult.name || name);
              _error2 = errorLookupResult.error;
              name = errorLookupResult.name;
              isValid = isEmptyObject(errors);
            }
            _context8.next = 47;
            break;
          case 31:
            _updateIsValidating([name], true);
            _context8.next = 34;
            return validateField(field, _names.disabled, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation);
          case 34:
            _context8.t0 = name;
            _error2 = _context8.sent[_context8.t0];
            _updateIsValidating([name]);
            _updateIsFieldValueUpdated(fieldValue);
            if (!isFieldValueUpdated) {
              _context8.next = 47;
              break;
            }
            if (!_error2) {
              _context8.next = 43;
              break;
            }
            isValid = false;
            _context8.next = 47;
            break;
          case 43:
            if (!(_proxyFormState.isValid || _proxySubscribeFormState.isValid)) {
              _context8.next = 47;
              break;
            }
            _context8.next = 46;
            return _executeBuiltInValidation(_fields, true);
          case 46:
            isValid = _context8.sent;
          case 47:
            if (isFieldValueUpdated) {
              field._f.deps && (!Array.isArray(field._f.deps) || field._f.deps.length > 0) && trigger(field._f.deps);
              shouldRenderByError(name, isValid, _error2, fieldState);
            }
          case 48:
          case "end":
            return _context8.stop();
        }
      }, _callee8);
    }));
    return function onChange(_x12) {
      return _ref12.apply(this, arguments);
    };
  }();
  var _focusInput = function _focusInput(ref, key) {
    if (_get(_formState.errors, key) && ref.focus) {
      ref.focus();
      return 1;
    }
    return;
  };
  var trigger = /*#__PURE__*/function () {
    var _ref13 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee0(name) {
      var options,
        isValid,
        validationResult,
        fieldNames,
        errors,
        _args0 = arguments;
      return _regeneratorRuntime().wrap(function _callee0$(_context0) {
        while (1) switch (_context0.prev = _context0.next) {
          case 0:
            options = _args0.length > 1 && _args0[1] !== undefined ? _args0[1] : {};
            fieldNames = convertToArrayPayload(name);
            if (!_options.resolver) {
              _context0.next = 10;
              break;
            }
            _context0.next = 5;
            return executeSchemaAndUpdateState(isUndefined(name) ? name : fieldNames);
          case 5:
            errors = _context0.sent;
            isValid = isEmptyObject(errors);
            validationResult = name ? !fieldNames.some(function (name) {
              return _get(errors, name);
            }) : isValid;
            _context0.next = 20;
            break;
          case 10:
            if (!name) {
              _context0.next = 17;
              break;
            }
            _context0.next = 13;
            return Promise.all(fieldNames.map(/*#__PURE__*/function () {
              var _ref14 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9(fieldName) {
                var field;
                return _regeneratorRuntime().wrap(function _callee9$(_context9) {
                  while (1) switch (_context9.prev = _context9.next) {
                    case 0:
                      field = _get(_fields, fieldName);
                      _context9.next = 3;
                      return _executeBuiltInValidation(field && field._f ? _defineProperty({}, fieldName, field) : field);
                    case 3:
                      return _context9.abrupt("return", _context9.sent);
                    case 4:
                    case "end":
                      return _context9.stop();
                  }
                }, _callee9);
              }));
              return function (_x14) {
                return _ref14.apply(this, arguments);
              };
            }()));
          case 13:
            validationResult = _context0.sent.every(Boolean);
            !(!validationResult && !_formState.isValid) && _setValid();
            _context0.next = 20;
            break;
          case 17:
            _context0.next = 19;
            return _executeBuiltInValidation(_fields);
          case 19:
            validationResult = isValid = _context0.sent;
          case 20:
            _subjects.state.next(_objectSpread(_objectSpread(_objectSpread({}, !isString(name) || (_proxyFormState.isValid || _proxySubscribeFormState.isValid) && isValid !== _formState.isValid ? {} : {
              name: name
            }), _options.resolver || !name ? {
              isValid: isValid
            } : {}), {}, {
              errors: _formState.errors
            }));
            options.shouldFocus && !validationResult && _iterateFieldsByAction(_fields, _focusInput, name ? fieldNames : _names.mount);
            return _context0.abrupt("return", validationResult);
          case 23:
          case "end":
            return _context0.stop();
        }
      }, _callee0);
    }));
    return function trigger(_x13) {
      return _ref13.apply(this, arguments);
    };
  }();
  var getValues = function getValues(fieldNames, config) {
    var values = _objectSpread({}, _state.mount ? _formValues : _defaultValues);
    if (config) {
      values = extractFormValues(config.dirtyFields ? _formState.dirtyFields : _formState.touchedFields, values);
    }
    return isUndefined(fieldNames) ? values : isString(fieldNames) ? _get(values, fieldNames) : fieldNames.map(function (name) {
      return _get(values, name);
    });
  };
  var getFieldState = function getFieldState(name, formState) {
    return {
      invalid: !!_get((formState || _formState).errors, name),
      isDirty: !!_get((formState || _formState).dirtyFields, name),
      error: _get((formState || _formState).errors, name),
      isValidating: !!_get(_formState.validatingFields, name),
      isTouched: !!_get((formState || _formState).touchedFields, name)
    };
  };
  var clearErrors = function clearErrors(name) {
    name && convertToArrayPayload(name).forEach(function (inputName) {
      return unset(_formState.errors, inputName);
    });
    _subjects.state.next({
      errors: name ? _formState.errors : {}
    });
  };
  var setError = function setError(name, error, options) {
    var ref = (_get(_fields, name, {
      _f: {}
    })._f || {}).ref;
    var currentError = _get(_formState.errors, name) || {};
    // Don't override existing error messages elsewhere in the object tree.
    var currentRef = currentError.ref,
      message = currentError.message,
      type = currentError.type,
      restOfErrorTree = _objectWithoutProperties(currentError, _excluded6);
    set(_formState.errors, name, _objectSpread(_objectSpread(_objectSpread({}, restOfErrorTree), error), {}, {
      ref: ref
    }));
    _subjects.state.next({
      name: name,
      errors: _formState.errors,
      isValid: false
    });
    options && options.shouldFocus && ref && ref.focus && ref.focus();
  };
  var watch = function watch(name, defaultValue) {
    return isFunction(name) ? _subjects.state.subscribe({
      next: function next(payload) {
        return 'values' in payload && name(_getWatch(undefined, defaultValue), payload);
      }
    }) : _getWatch(name, defaultValue, true);
  };
  var _subscribe = function _subscribe(props) {
    return _subjects.state.subscribe({
      next: function next(formState) {
        if (shouldSubscribeByName(props.name, formState.name, props.exact) && shouldRenderFormState(formState, props.formState || _proxyFormState, _setFormState, props.reRenderRoot)) {
          props.callback(_objectSpread(_objectSpread(_objectSpread({
            values: _objectSpread({}, _formValues)
          }, _formState), formState), {}, {
            defaultValues: _defaultValues
          }));
        }
      }
    }).unsubscribe;
  };
  var subscribe = function subscribe(props) {
    _state.mount = true;
    _proxySubscribeFormState = _objectSpread(_objectSpread({}, _proxySubscribeFormState), props.formState);
    return _subscribe(_objectSpread(_objectSpread({}, props), {}, {
      formState: _proxySubscribeFormState
    }));
  };
  var unregister = function unregister(name) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _iterator6 = _createForOfIteratorHelper(name ? convertToArrayPayload(name) : _names.mount),
      _step6;
    try {
      for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
        var fieldName = _step6.value;
        _names.mount.delete(fieldName);
        _names.array.delete(fieldName);
        if (!options.keepValue) {
          unset(_fields, fieldName);
          unset(_formValues, fieldName);
        }
        !options.keepError && unset(_formState.errors, fieldName);
        !options.keepDirty && unset(_formState.dirtyFields, fieldName);
        !options.keepTouched && unset(_formState.touchedFields, fieldName);
        !options.keepIsValidating && unset(_formState.validatingFields, fieldName);
        !_options.shouldUnregister && !options.keepDefaultValue && unset(_defaultValues, fieldName);
      }
    } catch (err) {
      _iterator6.e(err);
    } finally {
      _iterator6.f();
    }
    _subjects.state.next({
      values: cloneObject(_formValues)
    });
    _subjects.state.next(_objectSpread(_objectSpread({}, _formState), !options.keepDirty ? {} : {
      isDirty: _getDirty()
    }));
    !options.keepIsValid && _setValid();
  };
  var _setDisabledField = function _setDisabledField(_ref16) {
    var disabled = _ref16.disabled,
      name = _ref16.name;
    if (isBoolean(disabled) && _state.mount || !!disabled || _names.disabled.has(name)) {
      disabled ? _names.disabled.add(name) : _names.disabled.delete(name);
    }
  };
  var _register = function register(name) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var field = _get(_fields, name);
    var disabledIsDefined = isBoolean(options.disabled) || isBoolean(_options.disabled);
    set(_fields, name, _objectSpread(_objectSpread({}, field || {}), {}, {
      _f: _objectSpread(_objectSpread({}, field && field._f ? field._f : {
        ref: {
          name: name
        }
      }), {}, {
        name: name,
        mount: true
      }, options)
    }));
    _names.mount.add(name);
    if (field) {
      _setDisabledField({
        disabled: isBoolean(options.disabled) ? options.disabled : _options.disabled,
        name: name
      });
    } else {
      updateValidAndValue(name, true, options.value);
    }
    return _objectSpread(_objectSpread(_objectSpread({}, disabledIsDefined ? {
      disabled: options.disabled || _options.disabled
    } : {}), _options.progressive ? {
      required: !!options.required,
      min: getRuleValue(options.min),
      max: getRuleValue(options.max),
      minLength: getRuleValue(options.minLength),
      maxLength: getRuleValue(options.maxLength),
      pattern: getRuleValue(options.pattern)
    } : {}), {}, {
      name: name,
      onChange: onChange,
      onBlur: onChange,
      ref: function (_ref17) {
        function ref(_x15) {
          return _ref17.apply(this, arguments);
        }
        ref.toString = function () {
          return _ref17.toString();
        };
        return ref;
      }(function (ref) {
        if (ref) {
          _register(name, options);
          field = _get(_fields, name);
          var fieldRef = isUndefined(ref.value) ? ref.querySelectorAll ? ref.querySelectorAll('input,select,textarea')[0] || ref : ref : ref;
          var radioOrCheckbox = isRadioOrCheckbox(fieldRef);
          var refs = field._f.refs || [];
          if (radioOrCheckbox ? refs.find(function (option) {
            return option === fieldRef;
          }) : fieldRef === field._f.ref) {
            return;
          }
          set(_fields, name, {
            _f: _objectSpread(_objectSpread({}, field._f), radioOrCheckbox ? {
              refs: [].concat(_toConsumableArray(refs.filter(live)), [fieldRef], _toConsumableArray(Array.isArray(_get(_defaultValues, name)) ? [{}] : [])),
              ref: {
                type: fieldRef.type,
                name: name
              }
            } : {
              ref: fieldRef
            })
          });
          updateValidAndValue(name, false, undefined, fieldRef);
        } else {
          field = _get(_fields, name, {});
          if (field._f) {
            field._f.mount = false;
          }
          (_options.shouldUnregister || options.shouldUnregister) && !(isNameInFieldArray(_names.array, name) && _state.action) && _names.unMount.add(name);
        }
      })
    });
  };
  var _focusError = function _focusError() {
    return _options.shouldFocusError && _iterateFieldsByAction(_fields, _focusInput, _names.mount);
  };
  var _disableForm = function _disableForm(disabled) {
    if (isBoolean(disabled)) {
      _subjects.state.next({
        disabled: disabled
      });
      _iterateFieldsByAction(_fields, function (ref, name) {
        var currentField = _get(_fields, name);
        if (currentField) {
          ref.disabled = currentField._f.disabled || disabled;
          if (Array.isArray(currentField._f.refs)) {
            currentField._f.refs.forEach(function (inputRef) {
              inputRef.disabled = currentField._f.disabled || disabled;
            });
          }
        }
      }, 0, false);
    }
  };
  var handleSubmit = function handleSubmit(onValid, onInvalid) {
    return /*#__PURE__*/function () {
      var _ref18 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee1(e) {
        var onValidError, fieldValues, _yield$_runSchema3, errors, values, _iterator7, _step7, _name4;
        return _regeneratorRuntime().wrap(function _callee1$(_context1) {
          while (1) switch (_context1.prev = _context1.next) {
            case 0:
              onValidError = undefined;
              if (e) {
                e.preventDefault && e.preventDefault();
                e.persist && e.persist();
              }
              fieldValues = cloneObject(_formValues);
              _subjects.state.next({
                isSubmitting: true
              });
              if (!_options.resolver) {
                _context1.next = 14;
                break;
              }
              _context1.next = 7;
              return _runSchema();
            case 7:
              _yield$_runSchema3 = _context1.sent;
              errors = _yield$_runSchema3.errors;
              values = _yield$_runSchema3.values;
              _formState.errors = errors;
              fieldValues = cloneObject(values);
              _context1.next = 16;
              break;
            case 14:
              _context1.next = 16;
              return _executeBuiltInValidation(_fields);
            case 16:
              if (_names.disabled.size) {
                _iterator7 = _createForOfIteratorHelper(_names.disabled);
                try {
                  for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                    _name4 = _step7.value;
                    unset(fieldValues, _name4);
                  }
                } catch (err) {
                  _iterator7.e(err);
                } finally {
                  _iterator7.f();
                }
              }
              unset(_formState.errors, 'root');
              if (!isEmptyObject(_formState.errors)) {
                _context1.next = 30;
                break;
              }
              _subjects.state.next({
                errors: {}
              });
              _context1.prev = 20;
              _context1.next = 23;
              return onValid(fieldValues, e);
            case 23:
              _context1.next = 28;
              break;
            case 25:
              _context1.prev = 25;
              _context1.t0 = _context1["catch"](20);
              onValidError = _context1.t0;
            case 28:
              _context1.next = 35;
              break;
            case 30:
              if (!onInvalid) {
                _context1.next = 33;
                break;
              }
              _context1.next = 33;
              return onInvalid(_objectSpread({}, _formState.errors), e);
            case 33:
              _focusError();
              setTimeout(_focusError);
            case 35:
              _subjects.state.next({
                isSubmitted: true,
                isSubmitting: false,
                isSubmitSuccessful: isEmptyObject(_formState.errors) && !onValidError,
                submitCount: _formState.submitCount + 1,
                errors: _formState.errors
              });
              if (!onValidError) {
                _context1.next = 38;
                break;
              }
              throw onValidError;
            case 38:
            case "end":
              return _context1.stop();
          }
        }, _callee1, null, [[20, 25]]);
      }));
      return function (_x16) {
        return _ref18.apply(this, arguments);
      };
    }();
  };
  var resetField = function resetField(name) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (_get(_fields, name)) {
      if (isUndefined(options.defaultValue)) {
        setValue(name, cloneObject(_get(_defaultValues, name)));
      } else {
        setValue(name, options.defaultValue);
        set(_defaultValues, name, cloneObject(options.defaultValue));
      }
      if (!options.keepTouched) {
        unset(_formState.touchedFields, name);
      }
      if (!options.keepDirty) {
        unset(_formState.dirtyFields, name);
        _formState.isDirty = options.defaultValue ? _getDirty(name, cloneObject(_get(_defaultValues, name))) : _getDirty();
      }
      if (!options.keepError) {
        unset(_formState.errors, name);
        _proxyFormState.isValid && _setValid();
      }
      _subjects.state.next(_objectSpread({}, _formState));
    }
  };
  var _reset = function _reset(formValues) {
    var keepStateOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var updatedValues = formValues ? cloneObject(formValues) : _defaultValues;
    var cloneUpdatedValues = cloneObject(updatedValues);
    var isEmptyResetValues = isEmptyObject(formValues);
    var values = isEmptyResetValues ? _defaultValues : cloneUpdatedValues;
    if (!keepStateOptions.keepDefaultValues) {
      _defaultValues = updatedValues;
    }
    if (!keepStateOptions.keepValues) {
      if (keepStateOptions.keepDirtyValues) {
        var fieldsToCheck = new Set([].concat(_toConsumableArray(_names.mount), _toConsumableArray(Object.keys(getDirtyFields(_defaultValues, _formValues)))));
        for (var _i4 = 0, _Array$from = Array.from(fieldsToCheck); _i4 < _Array$from.length; _i4++) {
          var fieldName = _Array$from[_i4];
          _get(_formState.dirtyFields, fieldName) ? set(values, fieldName, _get(_formValues, fieldName)) : setValue(fieldName, _get(values, fieldName));
        }
      } else {
        if (isWeb && isUndefined(formValues)) {
          var _iterator8 = _createForOfIteratorHelper(_names.mount),
            _step8;
          try {
            for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
              var _name5 = _step8.value;
              var field = _get(_fields, _name5);
              if (field && field._f) {
                var fieldReference = Array.isArray(field._f.refs) ? field._f.refs[0] : field._f.ref;
                if (isHTMLElement(fieldReference)) {
                  var form = fieldReference.closest('form');
                  if (form) {
                    form.reset();
                    break;
                  }
                }
              }
            }
          } catch (err) {
            _iterator8.e(err);
          } finally {
            _iterator8.f();
          }
        }
        if (keepStateOptions.keepFieldsRef) {
          var _iterator9 = _createForOfIteratorHelper(_names.mount),
            _step9;
          try {
            for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
              var _fieldName = _step9.value;
              setValue(_fieldName, _get(values, _fieldName));
            }
          } catch (err) {
            _iterator9.e(err);
          } finally {
            _iterator9.f();
          }
        } else {
          _fields = {};
        }
      }
      _formValues = _options.shouldUnregister ? keepStateOptions.keepDefaultValues ? cloneObject(_defaultValues) : {} : cloneObject(values);
      _subjects.array.next({
        values: _objectSpread({}, values)
      });
      _subjects.state.next({
        values: _objectSpread({}, values)
      });
    }
    _names = {
      mount: keepStateOptions.keepDirtyValues ? _names.mount : new Set(),
      unMount: new Set(),
      array: new Set(),
      disabled: new Set(),
      watch: new Set(),
      watchAll: false,
      focus: ''
    };
    _state.mount = !_proxyFormState.isValid || !!keepStateOptions.keepIsValid || !!keepStateOptions.keepDirtyValues || !_options.shouldUnregister && !isEmptyObject(values);
    _state.watch = !!_options.shouldUnregister;
    _subjects.state.next({
      submitCount: keepStateOptions.keepSubmitCount ? _formState.submitCount : 0,
      isDirty: isEmptyResetValues ? false : keepStateOptions.keepDirty ? _formState.isDirty : !!(keepStateOptions.keepDefaultValues && !deepEqual(formValues, _defaultValues)),
      isSubmitted: keepStateOptions.keepIsSubmitted ? _formState.isSubmitted : false,
      dirtyFields: isEmptyResetValues ? {} : keepStateOptions.keepDirtyValues ? keepStateOptions.keepDefaultValues && _formValues ? getDirtyFields(_defaultValues, _formValues) : _formState.dirtyFields : keepStateOptions.keepDefaultValues && formValues ? getDirtyFields(_defaultValues, formValues) : keepStateOptions.keepDirty ? _formState.dirtyFields : {},
      touchedFields: keepStateOptions.keepTouched ? _formState.touchedFields : {},
      errors: keepStateOptions.keepErrors ? _formState.errors : {},
      isSubmitSuccessful: keepStateOptions.keepIsSubmitSuccessful ? _formState.isSubmitSuccessful : false,
      isSubmitting: false,
      defaultValues: _defaultValues
    });
  };
  var reset = function reset(formValues, keepStateOptions) {
    return _reset(isFunction(formValues) ? formValues(_formValues) : formValues, keepStateOptions);
  };
  var setFocus = function setFocus(name) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var field = _get(_fields, name);
    var fieldReference = field && field._f;
    if (fieldReference) {
      var fieldRef = fieldReference.refs ? fieldReference.refs[0] : fieldReference.ref;
      if (fieldRef.focus) {
        fieldRef.focus();
        options.shouldSelect && isFunction(fieldRef.select) && fieldRef.select();
      }
    }
  };
  var _setFormState = function _setFormState(updatedFormState) {
    _formState = _objectSpread(_objectSpread({}, _formState), updatedFormState);
  };
  var _resetDefaultValues = function _resetDefaultValues() {
    return isFunction(_options.defaultValues) && _options.defaultValues().then(function (values) {
      reset(values, _options.resetOptions);
      _subjects.state.next({
        isLoading: false
      });
    });
  };
  var methods = {
    control: {
      register: _register,
      unregister: unregister,
      getFieldState: getFieldState,
      handleSubmit: handleSubmit,
      setError: setError,
      _subscribe: _subscribe,
      _runSchema: _runSchema,
      _focusError: _focusError,
      _getWatch: _getWatch,
      _getDirty: _getDirty,
      _setValid: _setValid,
      _setFieldArray: _setFieldArray,
      _setDisabledField: _setDisabledField,
      _setErrors: _setErrors,
      _getFieldArray: _getFieldArray,
      _reset: _reset,
      _resetDefaultValues: _resetDefaultValues,
      _removeUnmounted: _removeUnmounted,
      _disableForm: _disableForm,
      _subjects: _subjects,
      _proxyFormState: _proxyFormState,
      get _fields() {
        return _fields;
      },
      get _formValues() {
        return _formValues;
      },
      get _state() {
        return _state;
      },
      set _state(value) {
        _state = value;
      },
      get _defaultValues() {
        return _defaultValues;
      },
      get _names() {
        return _names;
      },
      set _names(value) {
        _names = value;
      },
      get _formState() {
        return _formState;
      },
      get _options() {
        return _options;
      },
      set _options(value) {
        _options = _objectSpread(_objectSpread({}, _options), value);
      }
    },
    subscribe: subscribe,
    trigger: trigger,
    register: _register,
    handleSubmit: handleSubmit,
    watch: watch,
    setValue: setValue,
    getValues: getValues,
    reset: reset,
    resetField: resetField,
    clearErrors: clearErrors,
    unregister: unregister,
    setError: setError,
    setFocus: setFocus,
    getFieldState: getFieldState
  };
  return _objectSpread(_objectSpread({}, methods), {}, {
    formControl: methods
  });
}
var generateId = function generateId() {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  var d = typeof performance === 'undefined' ? Date.now() : performance.now() * 1000;
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16 + d) % 16 | 0;
    return (c == 'x' ? r : r & 0x3 | 0x8).toString(16);
  });
};
var getFocusFieldName = function getFocusFieldName(name, index) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return options.shouldFocus || isUndefined(options.shouldFocus) ? options.focusName || "".concat(name, ".").concat(isUndefined(options.focusIndex) ? index : options.focusIndex, ".") : '';
};
var appendAt = function appendAt(data, value) {
  return [].concat(_toConsumableArray(data), _toConsumableArray(convertToArrayPayload(value)));
};
var fillEmptyArray = function fillEmptyArray(value) {
  return Array.isArray(value) ? value.map(function () {
    return undefined;
  }) : undefined;
};
function insert(data, index, value) {
  return [].concat(_toConsumableArray(data.slice(0, index)), _toConsumableArray(convertToArrayPayload(value)), _toConsumableArray(data.slice(index)));
}
var moveArrayAt = function moveArrayAt(data, from, to) {
  if (!Array.isArray(data)) {
    return [];
  }
  if (isUndefined(data[to])) {
    data[to] = undefined;
  }
  data.splice(to, 0, data.splice(from, 1)[0]);
  return data;
};
var prependAt = function prependAt(data, value) {
  return [].concat(_toConsumableArray(convertToArrayPayload(value)), _toConsumableArray(convertToArrayPayload(data)));
};
function removeAtIndexes(data, indexes) {
  var i = 0;
  var temp = _toConsumableArray(data);
  var _iterator0 = _createForOfIteratorHelper(indexes),
    _step0;
  try {
    for (_iterator0.s(); !(_step0 = _iterator0.n()).done;) {
      var index = _step0.value;
      temp.splice(index - i, 1);
      i++;
    }
  } catch (err) {
    _iterator0.e(err);
  } finally {
    _iterator0.f();
  }
  return compact(temp).length ? temp : [];
}
var removeArrayAt = function removeArrayAt(data, index) {
  return isUndefined(index) ? [] : removeAtIndexes(data, convertToArrayPayload(index).sort(function (a, b) {
    return a - b;
  }));
};
var swapArrayAt = function swapArrayAt(data, indexA, indexB) {
  var _ref19 = [data[indexB], data[indexA]];
  data[indexA] = _ref19[0];
  data[indexB] = _ref19[1];
};
var updateAt = function updateAt(fieldValues, index, value) {
  fieldValues[index] = value;
  return fieldValues;
};

/**
 * A custom hook that exposes convenient methods to perform operations with a list of dynamic inputs that need to be appended, updated, removed etc. • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn) • [Video](https://youtu.be/4MrbfGSFY2A)
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usefieldarray) • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn)
 *
 * @param props - useFieldArray props
 *
 * @returns methods - functions to manipulate with the Field Arrays (dynamic inputs) {@link UseFieldArrayReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, control, handleSubmit, reset, trigger, setError } = useForm({
 *     defaultValues: {
 *       test: []
 *     }
 *   });
 *   const { fields, append } = useFieldArray({
 *     control,
 *     name: "test"
 *   });
 *
 *   return (
 *     <form onSubmit={handleSubmit(data => console.log(data))}>
 *       {fields.map((item, index) => (
 *          <input key={item.id} {...register(`test.${index}.firstName`)}  />
 *       ))}
 *       <button type="button" onClick={() => append({ firstName: "bill" })}>
 *         append
 *       </button>
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */
function useFieldArray(props) {
  var methods = useFormContext();
  var _props$control3 = props.control,
    control = _props$control3 === void 0 ? methods.control : _props$control3,
    name = props.name,
    _props$keyName = props.keyName,
    keyName = _props$keyName === void 0 ? 'id' : _props$keyName,
    shouldUnregister = props.shouldUnregister,
    rules = props.rules;
  var _React$useState7 = React.useState(control._getFieldArray(name)),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    fields = _React$useState8[0],
    setFields = _React$useState8[1];
  var ids = React.useRef(control._getFieldArray(name).map(generateId));
  var _actioned = React.useRef(false);
  control._names.array.add(name);
  React.useMemo(function () {
    return rules && fields.length >= 0 && control.register(name, rules);
  }, [control, name, fields.length, rules]);
  useIsomorphicLayoutEffect(function () {
    return control._subjects.array.subscribe({
      next: function next(_ref20) {
        var values = _ref20.values,
          fieldArrayName = _ref20.name;
        if (fieldArrayName === name || !fieldArrayName) {
          var fieldValues = _get(values, name);
          if (Array.isArray(fieldValues)) {
            setFields(fieldValues);
            ids.current = fieldValues.map(generateId);
          }
        }
      }
    }).unsubscribe;
  }, [control, name]);
  var updateValues = React.useCallback(function (updatedFieldArrayValues) {
    _actioned.current = true;
    control._setFieldArray(name, updatedFieldArrayValues);
  }, [control, name]);
  var append = function append(value, options) {
    var appendValue = convertToArrayPayload(cloneObject(value));
    var updatedFieldArrayValues = appendAt(control._getFieldArray(name), appendValue);
    control._names.focus = getFocusFieldName(name, updatedFieldArrayValues.length - 1, options);
    ids.current = appendAt(ids.current, appendValue.map(generateId));
    updateValues(updatedFieldArrayValues);
    setFields(updatedFieldArrayValues);
    control._setFieldArray(name, updatedFieldArrayValues, appendAt, {
      argA: fillEmptyArray(value)
    });
  };
  var prepend = function prepend(value, options) {
    var prependValue = convertToArrayPayload(cloneObject(value));
    var updatedFieldArrayValues = prependAt(control._getFieldArray(name), prependValue);
    control._names.focus = getFocusFieldName(name, 0, options);
    ids.current = prependAt(ids.current, prependValue.map(generateId));
    updateValues(updatedFieldArrayValues);
    setFields(updatedFieldArrayValues);
    control._setFieldArray(name, updatedFieldArrayValues, prependAt, {
      argA: fillEmptyArray(value)
    });
  };
  var remove = function remove(index) {
    var updatedFieldArrayValues = removeArrayAt(control._getFieldArray(name), index);
    ids.current = removeArrayAt(ids.current, index);
    updateValues(updatedFieldArrayValues);
    setFields(updatedFieldArrayValues);
    !Array.isArray(_get(control._fields, name)) && set(control._fields, name, undefined);
    control._setFieldArray(name, updatedFieldArrayValues, removeArrayAt, {
      argA: index
    });
  };
  var insert$1 = function insert$1(index, value, options) {
    var insertValue = convertToArrayPayload(cloneObject(value));
    var updatedFieldArrayValues = insert(control._getFieldArray(name), index, insertValue);
    control._names.focus = getFocusFieldName(name, index, options);
    ids.current = insert(ids.current, index, insertValue.map(generateId));
    updateValues(updatedFieldArrayValues);
    setFields(updatedFieldArrayValues);
    control._setFieldArray(name, updatedFieldArrayValues, insert, {
      argA: index,
      argB: fillEmptyArray(value)
    });
  };
  var swap = function swap(indexA, indexB) {
    var updatedFieldArrayValues = control._getFieldArray(name);
    swapArrayAt(updatedFieldArrayValues, indexA, indexB);
    swapArrayAt(ids.current, indexA, indexB);
    updateValues(updatedFieldArrayValues);
    setFields(updatedFieldArrayValues);
    control._setFieldArray(name, updatedFieldArrayValues, swapArrayAt, {
      argA: indexA,
      argB: indexB
    }, false);
  };
  var move = function move(from, to) {
    var updatedFieldArrayValues = control._getFieldArray(name);
    moveArrayAt(updatedFieldArrayValues, from, to);
    moveArrayAt(ids.current, from, to);
    updateValues(updatedFieldArrayValues);
    setFields(updatedFieldArrayValues);
    control._setFieldArray(name, updatedFieldArrayValues, moveArrayAt, {
      argA: from,
      argB: to
    }, false);
  };
  var update = function update(index, value) {
    var updateValue = cloneObject(value);
    var updatedFieldArrayValues = updateAt(control._getFieldArray(name), index, updateValue);
    ids.current = _toConsumableArray(updatedFieldArrayValues).map(function (item, i) {
      return !item || i === index ? generateId() : ids.current[i];
    });
    updateValues(updatedFieldArrayValues);
    setFields(_toConsumableArray(updatedFieldArrayValues));
    control._setFieldArray(name, updatedFieldArrayValues, updateAt, {
      argA: index,
      argB: updateValue
    }, true, false);
  };
  var replace = function replace(value) {
    var updatedFieldArrayValues = convertToArrayPayload(cloneObject(value));
    ids.current = updatedFieldArrayValues.map(generateId);
    updateValues(_toConsumableArray(updatedFieldArrayValues));
    setFields(_toConsumableArray(updatedFieldArrayValues));
    control._setFieldArray(name, _toConsumableArray(updatedFieldArrayValues), function (data) {
      return data;
    }, {}, true, false);
  };
  React.useEffect(function () {
    control._state.action = false;
    isWatched(name, control._names) && control._subjects.state.next(_objectSpread({}, control._formState));
    if (_actioned.current && (!getValidationModes(control._options.mode).isOnSubmit || control._formState.isSubmitted) && !getValidationModes(control._options.reValidateMode).isOnSubmit) {
      if (control._options.resolver) {
        control._runSchema([name]).then(function (result) {
          var error = _get(result.errors, name);
          var existingError = _get(control._formState.errors, name);
          if (existingError ? !error && existingError.type || error && (existingError.type !== error.type || existingError.message !== error.message) : error && error.type) {
            error ? set(control._formState.errors, name, error) : unset(control._formState.errors, name);
            control._subjects.state.next({
              errors: control._formState.errors
            });
          }
        });
      } else {
        var field = _get(control._fields, name);
        if (field && field._f && !(getValidationModes(control._options.reValidateMode).isOnSubmit && getValidationModes(control._options.mode).isOnSubmit)) {
          validateField(field, control._names.disabled, control._formValues, control._options.criteriaMode === VALIDATION_MODE.all, control._options.shouldUseNativeValidation, true).then(function (error) {
            return !isEmptyObject(error) && control._subjects.state.next({
              errors: updateFieldArrayRootError(control._formState.errors, error, name)
            });
          });
        }
      }
    }
    control._subjects.state.next({
      name: name,
      values: cloneObject(control._formValues)
    });
    control._names.focus && _iterateFieldsByAction(control._fields, function (ref, key) {
      if (control._names.focus && key.startsWith(control._names.focus) && ref.focus) {
        ref.focus();
        return 1;
      }
      return;
    });
    control._names.focus = '';
    control._setValid();
    _actioned.current = false;
  }, [fields, name, control]);
  React.useEffect(function () {
    !_get(control._formValues, name) && control._setFieldArray(name);
    return function () {
      var updateMounted = function updateMounted(name, value) {
        var field = _get(control._fields, name);
        if (field && field._f) {
          field._f.mount = value;
        }
      };
      control._options.shouldUnregister || shouldUnregister ? control.unregister(name) : updateMounted(name, false);
    };
  }, [name, control, keyName, shouldUnregister]);
  return {
    swap: React.useCallback(swap, [updateValues, name, control]),
    move: React.useCallback(move, [updateValues, name, control]),
    prepend: React.useCallback(prepend, [updateValues, name, control]),
    append: React.useCallback(append, [updateValues, name, control]),
    remove: React.useCallback(remove, [updateValues, name, control]),
    insert: React.useCallback(insert$1, [updateValues, name, control]),
    update: React.useCallback(update, [updateValues, name, control]),
    replace: React.useCallback(replace, [updateValues, name, control]),
    fields: React.useMemo(function () {
      return fields.map(function (field, index) {
        return _objectSpread(_objectSpread({}, field), {}, _defineProperty({}, keyName, ids.current[index] || generateId()));
      });
    }, [fields, keyName])
  };
}

/**
 * Custom hook to manage the entire form.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useform) • [Demo](https://codesandbox.io/s/react-hook-form-get-started-ts-5ksmm) • [Video](https://www.youtube.com/watch?v=RkXv4AXXC_4)
 *
 * @param props - form configuration and validation parameters.
 *
 * @returns methods - individual functions to manage the form state. {@link UseFormReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, watch, formState: { errors } } = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   console.log(watch("example"));
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input defaultValue="test" {...register("example")} />
 *       <input {...register("exampleRequired", { required: true })} />
 *       {errors.exampleRequired && <span>This field is required</span>}
 *       <button>Submit</button>
 *     </form>
 *   );
 * }
 * ```
 */
function useForm() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _formControl = React.useRef(undefined);
  var _values = React.useRef(undefined);
  var _React$useState9 = React.useState({
      isDirty: false,
      isValidating: false,
      isLoading: isFunction(props.defaultValues),
      isSubmitted: false,
      isSubmitting: false,
      isSubmitSuccessful: false,
      isValid: false,
      submitCount: 0,
      dirtyFields: {},
      touchedFields: {},
      validatingFields: {},
      errors: props.errors || {},
      disabled: props.disabled || false,
      isReady: false,
      defaultValues: isFunction(props.defaultValues) ? undefined : props.defaultValues
    }),
    _React$useState0 = _slicedToArray(_React$useState9, 2),
    formState = _React$useState0[0],
    updateFormState = _React$useState0[1];
  if (!_formControl.current) {
    if (props.formControl) {
      _formControl.current = _objectSpread(_objectSpread({}, props.formControl), {}, {
        formState: formState
      });
      if (props.defaultValues && !isFunction(props.defaultValues)) {
        props.formControl.reset(props.defaultValues, props.resetOptions);
      }
    } else {
      var _createFormControl = createFormControl(props),
        formControl = _createFormControl.formControl,
        rest = _objectWithoutProperties(_createFormControl, _excluded7);
      _formControl.current = _objectSpread(_objectSpread({}, rest), {}, {
        formState: formState
      });
    }
  }
  var control = _formControl.current.control;
  control._options = props;
  useIsomorphicLayoutEffect(function () {
    var sub = control._subscribe({
      formState: control._proxyFormState,
      callback: function callback() {
        return updateFormState(_objectSpread({}, control._formState));
      },
      reRenderRoot: true
    });
    updateFormState(function (data) {
      return _objectSpread(_objectSpread({}, data), {}, {
        isReady: true
      });
    });
    control._formState.isReady = true;
    return sub;
  }, [control]);
  React.useEffect(function () {
    return control._disableForm(props.disabled);
  }, [control, props.disabled]);
  React.useEffect(function () {
    if (props.mode) {
      control._options.mode = props.mode;
    }
    if (props.reValidateMode) {
      control._options.reValidateMode = props.reValidateMode;
    }
  }, [control, props.mode, props.reValidateMode]);
  React.useEffect(function () {
    if (props.errors) {
      control._setErrors(props.errors);
      control._focusError();
    }
  }, [control, props.errors]);
  React.useEffect(function () {
    props.shouldUnregister && control._subjects.state.next({
      values: control._getWatch()
    });
  }, [control, props.shouldUnregister]);
  React.useEffect(function () {
    if (control._proxyFormState.isDirty) {
      var isDirty = control._getDirty();
      if (isDirty !== formState.isDirty) {
        control._subjects.state.next({
          isDirty: isDirty
        });
      }
    }
  }, [control, formState.isDirty]);
  React.useEffect(function () {
    if (props.values && !deepEqual(props.values, _values.current)) {
      control._reset(props.values, _objectSpread({
        keepFieldsRef: true
      }, control._options.resetOptions));
      _values.current = props.values;
      updateFormState(function (state) {
        return _objectSpread({}, state);
      });
    } else {
      control._resetDefaultValues();
    }
  }, [control, props.values]);
  React.useEffect(function () {
    if (!control._state.mount) {
      control._setValid();
      control._state.mount = true;
    }
    if (control._state.watch) {
      control._state.watch = false;
      control._subjects.state.next(_objectSpread({}, control._formState));
    }
    control._removeUnmounted();
  });
  _formControl.current.formState = getProxyFormState(formState, control);
  return _formControl.current;
}

/**
 * Watch component that subscribes to form field changes and re-renders when watched fields update.
 *
 * @param control - The form control object from useForm
 * @param names - Array of field names to watch for changes
 * @param render - The function that receives watched values and returns ReactNode
 * @returns The result of calling render function with watched values
 *
 * @example
 * The `Watch` component only re-render when the values of `foo`, `bar`, and `baz.qux` change.
 * The types of `foo`, `bar`, and `baz.qux` are precisely inferred.
 *
 * ```tsx
 * const { control } = useForm();
 *
 * <Watch
 *   control={control}
 *   names={['foo', 'bar', 'baz.qux']}
 *   render={([foo, bar, baz_qux]) => <div>{foo}{bar}{baz_qux}</div>}
 * />
 * ```
 */
var Watch = function Watch(_ref21) {
  var control = _ref21.control,
    names = _ref21.names,
    render = _ref21.render;
  return render(useWatch({
    control: control,
    name: names
  }));
};
export { Controller, Form, FormProvider, Watch, appendErrors, createFormControl, _get as get, set, useController, useFieldArray, useForm, useFormContext, useFormState, useWatch };